const translate = {
  'save_2FA_password_text': {
    'en-US': `<p>This password is the key to unlocking access to your account with 2FA authentication in case you lose access to your smartphone.</p>
    <p>It is essential that you store your recovery password in a safe place and that you can quickly access it when needed.</p>
    <p>However, if your recovery password is lost, the release process may take time to review, which may cause unnecessary inconvenience.</p>`,
    'pt-BR': `<p>Essa senha é a chave para desbloquear o acesso à sua conta com autenticação em 2FA caso você perca o acesso ao seu smartphone.</p>
    <p>É essencial que você armazene sua senha de recuperação em um local seguro e que você possa acessá-la rapidamente quando necessário.</p>
    <p>No entanto de perda da sua senha de recuperação, o processo de liberação pode levar tempo para ser analisado, o que pode causar inconvenientes desnecessários.</p>`,
    'es-ES': `<p>Esta contraseña es la clave para desbloquear el acceso a su cuenta con autenticación 2FA en caso de que pierda el acceso a su teléfono inteligente.</p>
    <p>Es esencial que almacene su contraseña de recuperación en un lugar seguro y que pueda acceder a ella rápidamente cuando sea necesario.</p>
    <p>Sin embargo, si pierde su contraseña de recuperación, el proceso de liberación puede demorar en revisarse, lo que puede causar inconvenientes innecesarios.</p>`
  },
  'Register': {
    'en-US': null,
    'pt-BR': 'Cadastrar',
    'es-ES': 'Registrar'
  },
  'Your name': {
    'en-US': null,
    'pt-BR': 'Seu nome',
    'es-ES': 'Su nombre'
  },
  'Your email': {
    'en-US': null,
    'pt-BR': 'Seu e-mail',
    'es-ES': 'Su e-mail'
  },
  'Your password': {
    'en-US': null,
    'pt-BR': 'Sua senha',
    'es-ES': 'Tu contraseña'
  },
  'Your timezone': {
    'en-US': null,
    'pt-BR': 'Sua timezone',
    'es-ES': 'Tu timezone'
  },
  'Your locale': {
    'en-US': null,
    'pt-BR': 'Seu idioma',
    'es-ES': 'Su idioma'
  },
  'On-site': {
    'en-US': null,
    'pt-BR': 'Presencial',
    'es-ES': 'En persona'
  },
  'Indeed.com is a job search engine created in the United States in 2004.': {
    'en-US': null,
    'pt-BR': 'Indeed.com é um motor de busca de empregos criado nos Estados Unidos em 2004.',
    'es-ES': 'Indeed.com es un motor de búsqueda de empleo creado en Estados Unidos en 2004.'
  },
  'Google Jobs is a job search engine by Google that redirects the candidate to the company\'s careers page.': {
    'en-US': null,
    'pt-BR': 'Google Jobs é um motor de pesquisa de emprego do Google que redireciona o candidato para a página de carreiras da empresa.',
    'es-ES': 'Google Jobs es un motor de búsqueda de empleo de Google que redirige al candidato a la página de carreras de la empresa.'
  },
  'date_format': {
    'en-US': 'YYYY-MM-DD',
    'pt-BR': 'DD/MM/YYYY',
    'es-ES': 'DD/MM/YYYY'
  },
  'Remote': {
    'en-US': null,
    'pt-BR': 'Remoto',
    'es-ES': 'Remoto'
  },
  'Hybrid': {
    'en-US': null,
    'pt-BR': 'Híbrido',
    'es-ES': 'Híbrido'
  },
  'on-site': {
    'en-US': null,
    'pt-BR': 'presencial',
    'es-ES': 'en persona'
  },
  'remote': {
    'en-US': null,
    'pt-BR': 'remoto',
    'es-ES': 'remoto'
  },
  'hybrid': {
    'en-US': null,
    'pt-BR': 'híbrido',
    'es-ES': 'híbrido'
  },
  'Security': {
    'en-US': null,
    'pt-BR': 'Segurança',
    'es-ES': 'Seguridad'
  },
  'Two-step verification': {
    'en-US': null,
    'pt-BR': 'Verificação em duas etapas',
    'es-ES': 'Verificación de dos pasos'
  },
  'Enabled': {
    'en-US': null,
    'pt-BR': 'Habilitado',
    'es-ES': 'Habilitado'
  },
  'Disable two-step verification': {
    'en-US': null,
    'pt-BR': 'Desabilitar verificação em duas etapas',
    'es-ES': 'Desactiva la verificación en dos pasos'
  },
  'If you disable two-step verification, the account will no longer have the protection of a second login step.': {
    'en-US': null,
    'pt-BR': 'Se você desativar a verificação em duas etapas, a conta não vai mais ter a proteção de uma segunda etapa de login.',
    'es-ES': 'Si desactiva la verificación en dos pasos, la cuenta ya no tendrá la protección de un segundo paso de inicio de sesión.'
  },
  'Protect your account with an extra layer of security. A second login step can keep your account secure even if someone discovers your password. To activate 2-Step Verification, all you need is a smartphone.': {
    'en-US': null,
    'pt-BR': 'Proteja sua conta com uma camada extra de segurança. Uma segunda etapa de login pode manter sua conta segura mesmo se alguém descobrir sua senha. Para ativar a verificação em duas etapas, você só precisa de um smartphone.',
    'es-ES': 'Proteja su cuenta con una capa adicional de seguridad. Un segundo paso de inicio de sesión puede mantener su cuenta segura incluso si alguien descubre su contraseña. Para activar la verificación en dos pasos, todo lo que necesita es un teléfono inteligente.'
  },
  'Download the app': {
    'en-US': null,
    'pt-BR': 'Baixar o app',
    'es-ES': 'Descarga la aplicación'
  },
  'Connect phone': {
    'en-US': null,
    'pt-BR': 'Conectar telefone',
    'es-ES': 'Conectar teléfono'
  },
  'Consumption': {
    'en-US': null,
    'pt-BR': 'Consumo',
    'es-ES': 'Consumo'
  },
  'Parse resume': {
    'en-US': null,
    'pt-BR': 'Extrair currículo',
    'es-ES': 'Extraer currículum'
  },
  'Video interview invitation': {
    'en-US': null,
    'pt-BR': 'Convite vídeo entrevista',
    'es-ES': 'Invitación video entrevista'
  },
  'Meeting analysis': {
    'en-US': null,
    'pt-BR': 'Análise de reunião',
    'es-ES': 'Análisis de reunión'
  },
  'Save the recovery key': {
    'en-US': null,
    'pt-BR': 'Salvar a chave de recuperação',
    'es-ES': 'Guarde la clave de recuperación'
  },
  'Install a verification app on your phone': {
    'en-US': null,
    'pt-BR': 'Instale um app de verificação no seu celular',
    'es-ES': 'Instale una aplicación de verificación en su teléfono'
  },
  'You\'ll need to use a verification app like Google Authenticator. Install from your app store.': {
    'en-US': null,
    'pt-BR': 'Será preciso usar um app de verificação, como Google Authenticator. Instale a partir da sua app store.',
    'es-ES': 'Deberá usar una aplicación de verificación como Google Authenticator. Instalar desde su tienda de aplicaciones.'
  },
  'Already installed, go to step 2': {
    'en-US': null,
    'pt-BR': 'Já instalei, ir para etapa 2',
    'es-ES': 'Ya instalado, vaya al paso 2'
  },
  'Scan this QR code with your verification app': {
    'en-US': null,
    'pt-BR': 'Digitalize este código QR com seu app de verificação',
    'es-ES': 'Escanee este código QR con su aplicación de verificación'
  },
  'When your app scans the QR code, you\'ll receive a six-digit code.': {
    'en-US': null,
    'pt-BR': 'Quando seu app ler o código QR, você vai receber um código de seis dígitos.',
    'es-ES': 'Cuando su aplicación escanee el código QR, recibirá un código de seis dígitos.'
  },
  'Enter the six-digit code here': {
    'en-US': null,
    'pt-BR': 'Digite aqui o código de seis dígitos',
    'es-ES': 'Ingrese el código de seis dígitos aquí'
  },
  'Enter the app code below. Once you\'re signed in, we\'ll remember your phone number, so you can use it every time you sign in.': {
    'en-US': null,
    'pt-BR': 'Digite abaixo o código do app. Depois que se conectar, a gente vai lembrar seu telefone, assim você pode usar sempre que entrar.',
    'es-ES': 'Introduzca el código de la aplicación a continuación. Una vez que haya iniciado sesión, recordaremos su número de teléfono para que pueda usarlo cada vez que inicie sesión.'
  },
  'Six-digit code': {
    'en-US': null,
    'pt-BR': 'Código de seis dígitos',
    'es-ES': 'Código de seis dígitos'
  },
  'To go back': {
    'en-US': null,
    'pt-BR': 'Voltar',
    'es-ES': 'Volver'
  },
  'Save your recovery password': {
    'en-US': null,
    'pt-BR': 'Salve sua senha de recuperação',
    'es-ES': 'Guarde su contraseña de recuperación'
  },
  'Save this recovery password:': {
    'en-US': null,
    'pt-BR': 'Guarde essa senha de recuperação:',
    'es-ES': 'Guarde esta contraseña de recuperación:'
  },
  'Attention:': {
    'en-US': null,
    'pt-BR': 'Atenção:',
    'es-ES': 'Atención:'
  },
  'OK! I have already saved the recovery password in a safe place.': {
    'en-US': null,
    'pt-BR': 'Ok! Já guardei a senha de recuperação em um local seguro.',
    'es-ES': '¡DE ACUERDO! Ya guardé la contraseña de recuperación en un lugar seguro.'
  },
  'Enable two-step verification': {
    'en-US': null,
    'pt-BR': 'Ativar verificação em duas etapas',
    'es-ES': 'Habilita la verificación en dos pasos'
  },
  'Immediately': {
    'en-US': null,
    'pt-BR': 'Imediatamente',
    'es-ES': 'Inmediatamente'
  },
  'n_seconds': {
    'en-US': '{count} seconds | {count} second | {count} seconds',
    'pt-BR': '{count} segundos | {count} segundo | {count} segundos',
    'es-ES': '{count} segundos | {count} segundo | {count} segundos'
  },
  'n_minutes': {
    'en-US': '{count} minutes | {count} minute | {count} minutes',
    'pt-BR': '{count} minutos | {count} minuto | {count} minutos',
    'es-ES': '{count} minutos | {count} minuto | {count} minutos'
  },
  'n_hours': {
    'en-US': '{count} hours | {count} hour | {count} hours',
    'pt-BR': '{count} hora | {count} hora | {count} horas',
    'es-ES': '{count} hora | {count} hora | {count} horas'
  },
  'n_days': {
    'en-US': '{count} days | {count} day | {count} days',
    'pt-BR': '{count} dias | {count} dia | {count} dias',
    'es-ES': '{count} días | {count} día | {count} días'
  },
  'n_weeks': {
    'en-US': '{count} weeks | {count} week | {count} weeks',
    'pt-BR': '{count} semanas | {count} semana | {count} semanas',
    'es-ES': '{count} semanas | {count} semana | {count} semanas'
  },
  'Custom': {
    'en-US': null,
    'pt-BR': 'Personalizado',
    'es-ES': 'Disfraz'
  },
  'Skip weekand': {
    'en-US': null,
    'pt-BR': 'Pular fim de semana',
    'es-ES': 'Saltar el fin de semana'
  },
  'Set time': {
    'en-US': null,
    'pt-BR': 'Definir horário',
    'es-ES': 'Establecer un tiempo'
  },
  'Assigned type': {
    'en-US': null,
    'pt-BR': 'Tipo de atribuição',
    'es-ES': 'Tipo de asignación'
  },
  'Delay': {
    'en-US': null,
    'pt-BR': 'Delay',
    'es-ES': 'Delay'
  },
  'tomorrow_morning': {
    'en-US': 'Tomorrow morning ({date})',
    'pt-BR': 'Amanhã de manhã ({date})',
    'es-ES': 'Mañana por la mañana ({date})'
  },
  'tomorrow_afternoon': {
    'en-US': 'Tomorrow afternoon ({date})',
    'pt-BR': 'Amanhã de tarde ({date})',
    'es-ES': 'Mañana en la tarde ({date})'
  },
  'after_tomorrow': {
    'en-US': 'On {dayWeek} morning ({date})',
    'pt-BR': 'Na {dayWeek} de manhã ({date})',
    'es-ES': 'El {dayWeek} por la mañana ({date})'
  },
  'Other date and time': {
    'en-US': null,
    'pt-BR': 'Outra data e horário',
    'es-ES': 'Otra fecha y hora'
  },
  'Attachs': {
    'en-US': null,
    'pt-BR': 'Anexos',
    'es-ES': 'Archivos adjuntos'
  },
  'Intended position': {
    'en-US': null,
    'pt-BR': 'Cargo pretendido',
    'es-ES': 'Posición deseada'
  },
  'Activities': {
    'en-US': null,
    'pt-BR': 'Atividades',
    'es-ES': 'Actividades'
  },
  'Movements in the pipeline': {
    'en-US': null,
    'pt-BR': 'Movimentações na pipeline',
    'es-ES': 'Movimientos en la pipeline'
  },
  'Events': {
    'en-US': null,
    'pt-BR': 'Eventos',
    'es-ES': 'Eventos'
  },
  'Candidates in the pipeline': {
    'en-US': null,
    'pt-BR': 'Candidatos na pipeline',
    'es-ES': 'Candidatos en el tintero'
  },
  'Default date': {
    'en-US': null,
    'pt-BR': 'Data padrão',
    'es-ES': 'Fecha principal'
  },
  'Colunms': {
    'en-US': null,
    'pt-BR': 'Colunas',
    'es-ES': 'Columnas'
  },
  'Group by': {
    'en-US': null,
    'pt-BR': 'Agrupar por',
    'es-ES': 'Agrupar por'
  },
  'Segment by': {
    'en-US': null,
    'pt-BR': 'Segmentar por',
    'es-ES': 'Segmentar por'
  },
  'Metric': {
    'en-US': null,
    'pt-BR': 'Métrica',
    'es-ES': 'Métrico'
  },
  'Columns': {
    'en-US': null,
    'pt-BR': 'Colunas',
    'es-ES': 'Columnas'
  },
  'Add filter': {
    'en-US': null,
    'pt-BR': 'Adicionar filtro',
    'es-ES': 'Añadir filtro'
  },
  'Create with AI': {
    'en-US': null,
    'pt-BR': 'Criar com IA',
    'es-ES': 'Crear con IA'
  },
  'Use artificial intelligence to generate a scorecard template.': {
    'en-US': null,
    'pt-BR': 'Use inteligência artificial para gerar um template de scorecard.',
    'es-ES': 'Utilice inteligencia artificial para generar una plantilla de scorecard.'
  },
  'Combine templates': {
    'en-US': null,
    'pt-BR': 'Combinar templates',
    'es-ES': 'Combinar plantillas'
  },
  'Use global templates to create a new scorecard.': {
    'en-US': null,
    'pt-BR': 'Use templates globais para criar um novo scorecard.',
    'es-ES': 'Utilice plantillas globales para crear un nuevo scorecard.'
  },
  'Create from scratch': {
    'en-US': null,
    'pt-BR': 'Criar do zero',
    'es-ES': 'Crear desde cero'
  },
  'Create a scorecard from scratch.': {
    'en-US': null,
    'pt-BR': 'Crie um scorecard do zero.',
    'es-ES': 'Cree un scorecard desde cero.'
  },
  'Interview Stage': {
    'en-US': null,
    'pt-BR': 'Etapa de Entrevista',
    'es-ES': 'Etapa de entrevista'
  },
  'Screening Interview (More objective)': {
    'en-US': null,
    'pt-BR': 'Entrevista de Triagem (Mais objetiva)',
    'es-ES': 'Entrevista de selección (más objetiva)'
  },
  'Selection Interview (More in-depth)': {
    'en-US': null,
    'pt-BR': 'Entrevista de Seleção (Mais aprofundada)',
    'es-ES': 'Entrevista de selección (más profunda)'
  },
  'Interview Objective(s)': {
    'en-US': null,
    'pt-BR': 'Objetivo(s) da Entrevista',
    'es-ES': 'Objetivo(s) de la Entrevista'
  },
  'Behavioral Competencies (e.g., organization, leadership...)': {
    'en-US': null,
    'pt-BR': 'Competências Comportamentais (por exemplo, organização, liderança...)',
    'es-ES': 'Competencias Conductuales (por ejemplo, organización, liderazgo...)'
  },
  'Technical Knowledge': {
    'en-US': null,
    'pt-BR': 'Conhecimento Técnico',
    'es-ES': 'Conocimiento Técnico'
  },
  'Motivation and Goals (why this position? what are they expecting from it?)': {
    'en-US': null,
    'pt-BR': 'Motivação e Objetivos (por que esta posição? o que eles esperam dela?)',
    'es-ES': 'Motivación y Objetivos (¿por qué esta posición? ¿qué esperan de ella?)'
  },
  'Basic Requirements (experience, education, etc.)': {
    'en-US': null,
    'pt-BR': 'Requisitos Básicos (experiência, educação, etc.)',
    'es-ES': 'Requisitos Básicos (experiencia, educación, etc.)'
  },
  'Generate scorecard': {
    'en-US': null,
    'pt-BR': 'Gerar scorecard',
    'es-ES': 'Generar scorecard'
  },
  'Practical Information (schedule, location, salary expectations, availability)': {
    'en-US': null,
    'pt-BR': 'Informações Práticas (horário, local, expectativas salariais, disponibilidade)',
    'es-ES': 'Información Práctica (horario, ubicación, expectativas salariales, disponibilidad)'
  },
  'Interview Duration': {
    'en-US': null,
    'pt-BR': 'Duração da entrevista',
    'es-ES': 'Duración de la entrevista'
  },
  '15 minutes': {
    'en-US': null,
    'pt-BR': '15 minutos',
    'es-ES': '15 minutos'
  },
  '30 minutes': {
    'en-US': null,
    'pt-BR': '30 minutos',
    'es-ES': '30 minutos'
  },
  '45 minutes': {
    'en-US': null,
    'pt-BR': '45 minutos',
    'es-ES': '45 minutos'
  },
  '1 hour': {
    'en-US': null,
    'pt-BR': '1 hora',
    'es-ES': '1 hora'
  },
  '1 hour and 30 minutes': {
    'en-US': null,
    'pt-BR': '1 hora e 30 minutos',
    'es-ES': '1 hora y 30 minutos'
  },
  '2 hours': {
    'en-US': null,
    'pt-BR': '2 horas',
    'es-ES': '2 horas'
  },

  'New dashboard': {
    'en-US': null,
    'pt-BR': 'Novo dashboard',
    'es-ES': 'Nuevo dashboard'
  },
  'Group range': {
    'en-US': null,
    'pt-BR': 'Intervalo do grupo',
    'es-ES': 'Rango de grupo'
  },
  'New report': {
    'en-US': null,
    'pt-BR': 'Novo relatório',
    'es-ES': 'Nuevo reporte'
  },
  'Select the entity to start the report': {
    'en-US': null,
    'pt-BR': 'Selecione a entidade para iniciar o relatório',
    'es-ES': 'Seleccione la entidad para iniciar el reporte'
  },
  'Career site': {
    'en-US': null,
    'pt-BR': 'Site de carreiras',
    'es-ES': 'Sitio de carrera'
  },
  'Career sites': {
    'en-US': null,
    'pt-BR': 'Sites de carreiras',
    'es-ES': 'Sitios de carrera'
  },
  'Social': {
    'en-US': null,
    'pt-BR': 'Social',
    'es-ES': 'Social'
  },
  'Application notifications': {
    'en-US': null,
    'pt-BR': 'Notificações de candidatura',
    'es-ES': 'Notificaciones de candidatura'
  },
  'A more advanced career site builder is available. This page is dedicated to the legacy editing of career pages.': {
    'en-US': null,
    'pt-BR': 'Existe um construtor de site de carreiras mais avançado. Esta página se destina à edição legada das páginas de carreiras.',
    'es-ES': 'Existe un constructor de sitio de carreras más avanzado. Esta página está destinada a la edición heredada de las páginas de carreras.'
  },
  'Go to career sites': {
    'en-US': null,
    'pt-BR': 'Ir para sites de carreiras',
    'es-ES': 'Ir a sitios de carrera'
  },
  'Call': {
    'en-US': null,
    'pt-BR': 'Ligar',
    'es-ES': 'Llamar'
  },
  'Copy number': {
    'en-US': null,
    'pt-BR': 'Copiar número',
    'es-ES': 'Copia el numero'
  },
  'Open with WhatsApp': {
    'en-US': null,
    'pt-BR': 'Abrir com WhatsApp',
    'es-ES': 'Abrir con WhatsApp'
  },
  'Origin': {
    'en-US': null,
    'pt-BR': 'Origem',
    'es-ES': 'Origen'
  },
  'Sourced': {
    'en-US': null,
    'pt-BR': 'Fornecido',
    'es-ES': 'Proporcionó'
  },
  'Remained': {
    'en-US': null,
    'pt-BR': 'Permaneceram',
    'es-ES': 'Se mantuvo'
  },
  'Proceeded': {
    'en-US': null,
    'pt-BR': 'Prosseguiram',
    'es-ES': 'Procedieron'
  },
  'Referred': {
    'en-US': null,
    'pt-BR': 'Indicado',
    'es-ES': 'Indicado'
  },
  'Applied': {
    'en-US': null,
    'pt-BR': 'Aplicado',
    'es-ES': 'Aplicado'
  },
  'Custom HTML in HEAD': {
    'en-US': null,
    'pt-BR': 'HTML personalizado no HEAD',
    'es-ES': 'HTML personalizado en HEAD'
  },
  'Custom html (including scripts) attached at the end of the < head > section.': {
    'en-US': null,
    'pt-BR': 'HTML personalizado (incluindo scripts) inseridos no final da seção < head >.',
    'es-ES': 'HTML personalizado (incluidos los scripts) insertado al final de la sección < head >.'
  },
  'Custom HTML in BODY': {
    'en-US': null,
    'pt-BR': 'HTML personalizado no BODY',
    'es-ES': 'HTML personalizado en BODY'
  },
  'Custom html (including scripts) attached at the end of the < body > section.': {
    'en-US': null,
    'pt-BR': 'HTML personalizado (incluindo scripts) inseridos no final da seção < body >.',
    'es-ES': 'HTML personalizado (incluidos los scripts) insertado al final de la sección < body >.'
  },
  'Default image': {
    'en-US': null,
    'pt-BR': 'Imagem padrão',
    'es-ES': 'Imagen predeterminada'
  },
  'Image': {
    'en-US': null,
    'pt-BR': 'Imagem',
    'es-ES': 'Imagen'
  },
  'Set a default image for your careers site. You can change images for a certain page in page settings.': {
    'en-US': null,
    'pt-BR': 'Defina uma imagem padrão para o seu site de carreiras.',
    'es-ES': 'Establezca una imagen predeterminada para su sitio de carreras.'
  },
  'Find template': {
    'en-US': null,
    'pt-BR': 'Encontrar template',
    'es-ES': 'Encontrar template'
  },
  'Requisition templates': {
    'en-US': null,
    'pt-BR': 'Templates de requisição',
    'es-ES': 'Templates de requisicione'
  },
  'No templates found': {
    'en-US': null,
    'pt-BR': 'Nenhum template encontrado',
    'es-ES': 'No se encontraron plantillas'
  },
  'Requisition template': {
    'en-US': null,
    'pt-BR': 'Template de requisição',
    'es-ES': 'Template de requisicione'
  },
  'New template': {
    'en-US': null,
    'pt-BR': 'Novo template',
    'es-ES': 'Nuevo template'
  },
  'Mark as new': {
    'en-US': null,
    'pt-BR': 'Marcar como novo',
    'es-ES': 'Marcar como nuevo'
  },
  'No data to display': {
    'en-US': null,
    'pt-BR': 'Não há dados para exibir',
    'es-ES': 'No hay datos para mostrar'
  },
  'Status update date': {
    'en-US': null,
    'pt-BR': 'Data da atualização do status',
    'es-ES': 'Fecha de actualización de estado'
  },
  'Certification': {
    'en-US': null,
    'pt-BR': 'Certificação',
    'es-ES': 'Certificación'
  },
  'Doctorate': {
    'en-US': null,
    'pt-BR': 'Doutorado',
    'es-ES': 'Doctorado'
  },
  'High school': {
    'en-US': null,
    'pt-BR': 'Ensino médio',
    'es-ES': 'Escuela secundaria'
  },
  'Bachelor degree': {
    'en-US': null,
    'pt-BR': 'Graduação',
    'es-ES': 'Graduación'
  },
  'Master degree': {
    'en-US': null,
    'pt-BR': 'Mestrado',
    'es-ES': 'Maestría'
  },
  'Post doctorate': {
    'en-US': null,
    'pt-BR': 'Pós doutorado',
    'es-ES': 'Postdoctorado'
  },
  'Graduate degree': {
    'en-US': null,
    'pt-BR': 'Pós graduação/MBA',
    'es-ES': 'Postgrado / MBA'
  },
  'Vocational': {
    'en-US': null,
    'pt-BR': 'Técnico',
    'es-ES': 'Técnico'
  },
  'Associate degree': {
    'en-US': null,
    'pt-BR': 'Tecnólogo',
    'es-ES': 'Tecnólogo'
  },
  'Unlisted': {
    'en-US': null,
    'pt-BR': 'Não listado',
    'es-ES': 'No enlistado'
  },
  'New talent pool': {
    'en-US': null,
    'pt-BR': 'Novo talent pool',
    'es-ES': 'Nuevo talent pool'
  },
  'Jobs/Pools': {
    'en-US': null,
    'pt-BR': 'Vagas/Pools',
    'es-ES': 'Trabajos/Pools'
  },
  'Jobs': {
    'en-US': null,
    'pt-BR': 'Vagas',
    'es-ES': 'Trabajos'
  },
  'Requisitions': {
    'en-US': null,
    'pt-BR': 'Requisições',
    'es-ES': 'Requisiciones'
  },
  'Candidates': {
    'en-US': null,
    'pt-BR': 'Candidatos',
    'es-ES': 'Candidatos'
  },
  'Calendar': {
    'en-US': null,
    'pt-BR': 'Calendário',
    'es-ES': 'Calendario'
  },
  'E-mails': {
    'en-US': null,
    'pt-BR': 'E-mails',
    'es-ES': 'E-mails'
  },
  'Headline': {
    'en-US': null,
    'pt-BR': 'Cargo',
    'es-ES': 'Cargo'
  },
  'Position': {
    'en-US': null,
    'pt-BR': 'Cargo',
    'es-ES': 'Cargo'
  },
  'Tasks': {
    'en-US': null,
    'pt-BR': 'Tarefas',
    'es-ES': 'Tareas'
  },
  'My accounts': {
    'en-US': null,
    'pt-BR': 'Minhas contas',
    'es-ES': 'Mis cuentas'
  },
  'Logout': {
    'en-US': null,
    'pt-BR': 'Sair',
    'es-ES': 'Cerrar sesión'
  },
  'Careers site': {
    'en-US': null,
    'pt-BR': 'Site de carreiras',
    'es-ES': 'Sitio de carreras'
  },
  'Find candidate': {
    'en-US': null,
    'pt-BR': 'Encontrar candidato',
    'es-ES': 'Encontrar candidato'
  },
  'Account name': {
    'en-US': null,
    'pt-BR': 'Nome da empresa',
    'es-ES': 'Nombre de la cuenta'
  },
  'Title': {
    'en-US': null,
    'pt-BR': 'Título',
    'es-ES': 'Título'
  },
  'Group title': {
    'en-US': null,
    'pt-BR': 'Título do grupo',
    'es-ES': 'Título del grupo'
  },
  'Jobs/Requisitions': {
    'en-US': null,
    'pt-BR': 'Vagas/Requisição',
    'es-ES': 'Trabajos/Requisicione'
  },
  'Jobs and requisitions': {
    'en-US': null,
    'pt-BR': 'Vagas e requisições',
    'es-ES': 'Trabajos y requisiciones'
  },
  'Hiring manager': {
    'en-US': null,
    'pt-BR': 'Requisitante',
    'es-ES': 'Jefe inmediato'
  },
  'Name': {
    'en-US': null,
    'pt-BR': 'Nome',
    'es-ES': 'Nombre'
  },
  'Interview Type': {
    'en-US': null,
    'pt-BR': 'Tipo de entrevista',
    'es-ES': 'Tipo de entrevista'
  },
  'Conventional': {
    'en-US': null,
    'pt-BR': 'Convencional',
    'es-ES': 'Convencional'
  },
  'Voice AI Interview': {
    'en-US': null,
    'pt-BR': 'Entrevista de voz com IA',
    'es-ES': 'Entrevista de voz con IA'
  },
  'Voice AI Interview Responded': {
    'en-US': null,
    'pt-BR': 'Entrevista de voz com IA respondida',
    'es-ES': 'Entrevista de voz con IA respondida'
  },
  'Body': {
    'en-US': null,
    'pt-BR': 'Corpo',
    'es-ES': 'Cuerpo'
  },
  'Scorecard Settings': {
    'en-US': null,
    'pt-BR': 'Configurações do Scorecard',
    'es-ES': 'Configuración de Scorecard'
  },
  'Voice Interview Settings': {
    'en-US': null,
    'pt-BR': 'Configurações da Entrevista de Voz',
    'es-ES': 'Configuración de la entrevista de voz'
  },
  'Profile': {
    'en-US': null,
    'pt-BR': 'Perfil',
    'es-ES': 'Perfil'
  },
  'My profile': {
    'en-US': null,
    'pt-BR': 'Meu perfil',
    'es-ES': 'Mi perfil'
  },
  'Calendar settings': {
    'en-US': null,
    'pt-BR': 'Configurações de calendário',
    'es-ES': 'Configuración de calendario'
  },
  'Change password': {
    'en-US': null,
    'pt-BR': 'Trocar senha',
    'es-ES': 'Cambiar la contraseña'
  },
  'Notifications': {
    'en-US': null,
    'pt-BR': 'Notificações',
    'es-ES': 'Notificaciones'
  },
  'Chrome Extension': {
    'en-US': null,
    'pt-BR': 'Extensão do Chrome',
    'es-ES': 'Extensión de Chrome'
  },
  'Account / Careers': {
    'en-US': null,
    'pt-BR': 'Conta / Carreiras',
    'es-ES': 'Cuenta / Carreras'
  },
  'Accounts': {
    'en-US': null,
    'pt-BR': 'Contas',
    'es-ES': 'Cuentas'
  },
  'Account': {
    'en-US': null,
    'pt-BR': 'Conta',
    'es-ES': 'Cuenta'
  },
  'Domains': {
    'en-US': null,
    'pt-BR': 'Domínios',
    'es-ES': 'Dominios'
  },
  'Apply fields': {
    'en-US': null,
    'pt-BR': 'Campos de candidatura',
    'es-ES': 'Campos de aplicación'
  },
  'Website / Social': {
    'en-US': null,
    'pt-BR': 'Website / Social',
    'es-ES': 'Sitio web / Social'
  },
  'Career page': {
    'en-US': null,
    'pt-BR': 'Página de carreiras',
    'es-ES': 'Página de carrera'
  },
  'Members': {
    'en-US': null,
    'pt-BR': 'Membros',
    'es-ES': 'Miembros'
  },
  'Roles': {
    'en-US': null,
    'pt-BR': 'Grupos de permissões',
    'es-ES': 'Grupos de permisos'
  },
  'Companies': {
    'en-US': null,
    'pt-BR': 'Empresas',
    'es-ES': 'Empresas'
  },
  'Departaments': {
    'en-US': null,
    'pt-BR': 'Departamentos',
    'es-ES': 'Departamentos'
  },
  'Approval flow': {
    'en-US': null,
    'pt-BR': 'Fluxo de aprovação',
    'es-ES': 'Flujo de aprobación'
  },
  'Requisition approval flow': {
    'en-US': null,
    'pt-BR': 'Fluxo de aprovação da requisição',
    'es-ES': 'Solicitar flujo de aprobación'
  },
  'Contrat types': {
    'en-US': null,
    'pt-BR': 'Tipos de contrato',
    'es-ES': 'Tipos de contrato'
  },
  'Tags': {
    'en-US': null,
    'pt-BR': 'Tags',
    'es-ES': 'Etiquetas'
  },
  'Questionnaires/Tests': {
    'en-US': null,
    'pt-BR': 'Questionários/Testes',
    'es-ES': 'Cuestionarios / Pruebas'
  },
  'Video forms': {
    'en-US': null,
    'pt-BR': 'Vídeo formulários',
    'es-ES': 'Formularios de video'
  },
  'Scorecards': {
    'en-US': null,
    'pt-BR': 'Scorecards',
    'es-ES': 'Scorecards'
  },
  'Sources': {
    'en-US': null,
    'pt-BR': 'Fontes',
    'es-ES': 'Fuentes'
  },
  'Stages': {
    'en-US': null,
    'pt-BR': 'Etapas',
    'es-ES': 'Pasos'
  },
  'Email templates': {
    'en-US': null,
    'pt-BR': 'Templates de e-mail',
    'es-ES': 'Plantillas de e-mail'
  },
  'Shared candidates': {
    'en-US': null,
    'pt-BR': 'Candidatos compartilhados',
    'es-ES': 'Candidatos compartidos'
  },
  'Settings': {
    'en-US': null,
    'pt-BR': 'Configurações',
    'es-ES': 'Configuración'
  },
  'Integrations': {
    'en-US': null,
    'pt-BR': 'Integrações',
    'es-ES': 'Integraciones'
  },
  'Custom fields': {
    'en-US': null,
    'pt-BR': 'Campos customizados',
    'es-ES': 'Campos personalizados'
  },
  'Company': {
    'en-US': null,
    'pt-BR': 'Empresa',
    'es-ES': 'Compañía'
  },
  // 'Pipeline': {
  //   'en-US': null,
  //   'pt-BR': 'Processo',
  //   'es-ES': 'Proceso'
  // },
  'Filters': {
    'en-US': null,
    'pt-BR': 'Filtros',
    'es-ES': 'Filtros'
  },
  'Report': {
    'en-US': null,
    'pt-BR': 'Relatório',
    'es-ES': 'Informe'
  },
  'Reports': {
    'en-US': null,
    'pt-BR': 'Relatórios',
    'es-ES': 'Informes'
  },
  'History': {
    'en-US': null,
    'pt-BR': 'Histórico',
    'es-ES': 'Histórico'
  },
  'Files': {
    'en-US': null,
    'pt-BR': 'Arquivos',
    'es-ES': 'Archivos'
  },
  'Advertise': {
    'en-US': null,
    'pt-BR': 'Divulgação',
    'es-ES': 'Publicidad'
  },
  'Edit': {
    'en-US': null,
    'pt-BR': 'Editar',
    'es-ES': 'Editar'
  },
  'Editor': {
    'en-US': null,
    'pt-BR': 'Editor',
    'es-ES': 'Editor'
  },
  'Legacy editor': {
    'en-US': null,
    'pt-BR': 'Editor legado',
    'es-ES': 'Editor heredado'
  },
  'This site is in legacy mode. A new editor experience is available: to use it, create a new career site.': {
    'en-US': null,
    'pt-BR': 'Este site está no modo legado. Existe uma nova experiência de editor: para acessá-la, crie um novo site de carreiras.',
    'es-ES': 'Este sitio está en modo heredado. Existe una nueva experiencia de editor: para acceder, cree un nuevo sitio de carreras.'
  },
  'View site': {
    'en-US': null,
    'pt-BR': 'Ver site',
    'es-ES': 'Ver sitio'
  },
  'Clone': {
    'en-US': null,
    'pt-BR': 'Clonar',
    'es-ES': 'Clonar'
  },
  'Archive': {
    'en-US': null,
    'pt-BR': 'Arquivar',
    'es-ES': 'Archivo'
  },
  'Remove': {
    'en-US': null,
    'pt-BR': 'Remover',
    'es-ES': 'Eliminar'
  },
  'Owner': {
    'en-US': null,
    'pt-BR': 'Responsável',
    'es-ES': 'Dueño'
  },
  'Evaluations': {
    'en-US': null,
    'pt-BR': 'Avaliações',
    'es-ES': 'Evaluaciones'
  },
  'Evaluation': {
    'en-US': null,
    'pt-BR': 'Avaliação',
    'es-ES': 'Evaluación'
  },
  'Videos': {
    'en-US': null,
    'pt-BR': 'Vídeos',
    'es-ES': 'Videos'
  },
  'Video': {
    'en-US': null,
    'pt-BR': 'Vídeo',
    'es-ES': 'Video'
  },
  'Tests': {
    'en-US': null,
    'pt-BR': 'Testes',
    'es-ES': 'Pruebas'
  },
  'Test': {
    'en-US': null,
    'pt-BR': 'Teste',
    'es-ES': 'Prueba'
  },
  'Notes': {
    'en-US': null,
    'pt-BR': 'Notas',
    'es-ES': 'Notas'
  },
  'Messages': {
    'en-US': null,
    'pt-BR': 'Mensagens',
    'es-ES': 'Mensajes'
  },
  'Schedules': {
    'en-US': null,
    'pt-BR': 'Agendamentos',
    'es-ES': 'Horarios'
  },
  'More': {
    'en-US': null,
    'pt-BR': 'Mais',
    'es-ES': 'Más'
  },
  'Questionnaires': {
    'en-US': null,
    'pt-BR': 'Questionários',
    'es-ES': 'Cuestionarios'
  },
  'Questionnaire': {
    'en-US': null,
    'pt-BR': 'Questionário',
    'es-ES': 'Cuestionario'
  },
  'Shares': {
    'en-US': null,
    'pt-BR': 'Compartilhamentos',
    'es-ES': 'Comparte'
  },
  'Export': {
    'en-US': null,
    'pt-BR': 'Exportar',
    'es-ES': 'Exportar'
  },
  'Import': {
    'en-US': null,
    'pt-BR': 'Importar',
    'es-ES': 'Importar'
  },
  'Entity': {
    'en-US': null,
    'pt-BR': 'Entidade',
    'es-ES': 'Entidad'
  },
  'Size': {
    'en-US': null,
    'pt-BR': 'Tamanho',
    'es-ES': 'Tamaño'
  },
  'There are no items': {
    'en-US': null,
    'pt-BR': 'Não há registros',
    'es-ES': 'No hay elementos'
  },
  'Connections / Integrations': {
    'en-US': 'Connections / Integrations',
    'pt-BR': 'Conexões / Integrações',
    'es-ES': 'Conexiones / Integraciones'
  },
  'integration_category_channel': {
    'en-US': 'Channel',
    'pt-BR': 'Canal',
    'es-ES': 'Canal'
  },
  'Connect': {
    'en-US': 'Connect',
    'pt-BR': 'Conectar',
    'es-ES': 'Conectar'
  },
  'Connected': {
    'en-US': 'Connected',
    'pt-BR': 'Conectado',
    'es-ES': 'Conectado'
  },
  'Disconnected': {
    'en-US': 'Disconnected',
    'pt-BR': 'Desconectado',
    'es-ES': 'Desconectado'
  },
  'Select': {
    'en-US': 'Select',
    'pt-BR': 'Selecione',
    'es-ES': 'Seleccione'
  },
  'integration_connect_default': {
    'en-US': 'Connect this integration to your account.',
    'pt-BR': 'Conecte esta integração à sua conta.',
    'es-ES': 'Conecta esta integración a tu cuenta.'
  },
  'whatsapp_connect_intro': {
    'en-US': 'Connect WhatsApp Business to talk to candidates directly through WhatsApp.',
    'pt-BR': 'Conecte o WhatsApp Business para conversar com candidatos diretamente pelo WhatsApp.',
    'es-ES': 'Conecta WhatsApp Business para hablar con los candidatos directamente por WhatsApp.'
  },
  'whatsapp_connect_step_1': {
    'en-US': 'Click Connect to start the authentication.',
    'pt-BR': 'Clique em Conectar para iniciar a autenticação.',
    'es-ES': 'Haz clic en Conectar para iniciar la autenticación.'
  },
  'whatsapp_connect_step_2': {
    'en-US': 'Sign in with your WhatsApp Business account and authorize access.',
    'pt-BR': 'Faça login com sua conta do WhatsApp Business e autorize o acesso.',
    'es-ES': 'Inicia sesión con tu cuenta de WhatsApp Business y autoriza el acceso.'
  },
  'whatsapp_connect_step_3': {
    'en-US': 'Once connected, you can talk to candidates through WhatsApp.',
    'pt-BR': 'Depois de conectado, você poderá conversar com os candidatos pelo WhatsApp.',
    'es-ES': 'Una vez conectado, podrás hablar con los candidatos por WhatsApp.'
  },
  'whatsapp_connect_cancelled': {
    'en-US': 'Connection cancelled before finishing.',
    'pt-BR': 'Conexão cancelada antes de concluir.',
    'es-ES': 'Conexión cancelada antes de finalizar.'
  },
  'whatsapp_connect_error': {
    'en-US': 'Something went wrong while connecting WhatsApp. Please try again.',
    'pt-BR': 'Ocorreu um erro ao conectar o WhatsApp. Tente novamente.',
    'es-ES': 'Ocurrió un error al conectar WhatsApp. Inténtalo de nuevo.'
  },
  'whatsapp_connect_sdk_not_ready': {
    'en-US': 'WhatsApp is still loading. Please wait a moment and try again.',
    'pt-BR': 'O WhatsApp ainda está carregando. Aguarde um momento e tente novamente.',
    'es-ES': 'WhatsApp aún se está cargando. Espera un momento e inténtalo de nuevo.'
  },
  'Refresh': {
    'en-US': 'Refresh',
    'pt-BR': 'Atualizar',
    'es-ES': 'Actualizar'
  },
  'Message templates': {
    'en-US': 'Message templates',
    'pt-BR': 'Modelos de mensagem',
    'es-ES': 'Plantillas de mensaje'
  },
  'Create template': {
    'en-US': 'Create template',
    'pt-BR': 'Criar modelo',
    'es-ES': 'Crear plantilla'
  },
  'Add template': {
    'en-US': 'Add template',
    'pt-BR': 'Adicionar modelo',
    'es-ES': 'Agregar plantilla'
  },
  'Category': {
    'en-US': 'Category',
    'pt-BR': 'Categoria',
    'es-ES': 'Categoría'
  },
  'Parameter format': {
    'en-US': 'Parameter format',
    'pt-BR': 'Formato do parâmetro',
    'es-ES': 'Formato del parámetro'
  },
  'Footer': {
    'en-US': 'Footer',
    'pt-BR': 'Rodapé',
    'es-ES': 'Pie de página'
  },
  'Example values': {
    'en-US': 'Example values',
    'pt-BR': 'Valores de exemplo',
    'es-ES': 'Valores de ejemplo'
  },
  'whatsapp_template_body_help': {
    'en-US': 'Use {{1}}, {{2}}... for positional variables.',
    'pt-BR': 'Use {{1}}, {{2}}... para variáveis posicionais.',
    'es-ES': 'Usa {{1}}, {{2}}... para variables posicionales.'
  },
  'Something went wrong': {
    'en-US': 'Something went wrong',
    'pt-BR': 'Algo deu errado',
    'es-ES': 'Algo salió mal'
  },
  'Your connections': {
    'en-US': 'Your connections',
    'pt-BR': 'Suas conexões',
    'es-ES': 'Tus conexiones'
  },
  'Available integrations': {
    'en-US': 'Available integrations',
    'pt-BR': 'Integrações disponíveis',
    'es-ES': 'Integraciones disponibles'
  },
  'Configure': {
    'en-US': 'Configure',
    'pt-BR': 'Configurar',
    'es-ES': 'Configurar'
  },
  'Company Page ID': {
    'en-US': 'Company Page ID',
    'pt-BR': 'ID da Company Page',
    'es-ES': 'ID de la Company Page'
  },
  'Application type': {
    'en-US': 'Application type',
    'pt-BR': 'Tipo de candidatura',
    'es-ES': 'Tipo de candidatura'
  },
  'Indeed Apply': {
    'en-US': 'Indeed Apply',
    'pt-BR': 'Indeed Apply',
    'es-ES': 'Indeed Apply'
  },
  'indeed_apply_help': {
    'en-US': 'Candidates can apply directly through Indeed (Recommended)',
    'pt-BR': 'O candidato poderá se candidatar diretamente pelo Indeed (Recomendado)',
    'es-ES': 'El candidato podrá postularse directamente por Indeed (Recomendado)'
  },
  'Redirect': {
    'en-US': 'Redirect',
    'pt-BR': 'Redirecionar',
    'es-ES': 'Redireccionar'
  },
  'indeed_redirect_help': {
    'en-US': 'The candidate is redirected to the job on the careers page',
    'pt-BR': 'O candidato é redirecionado para vaga na página de carreiras',
    'es-ES': 'El candidato es redirigido a la vacante en la página de carreras'
  },
  'Contacts': {
    'en-US': null,
    'pt-BR': 'Contatos',
    'es-ES': 'Contactos'
  },
  'Pages': {
    'en-US': null,
    'pt-BR': 'Páginas',
    'es-ES': 'Paginas'
  },
  'Details': {
    'en-US': null,
    'pt-BR': 'Detalhes',
    'es-ES': 'Detalles'
  },
  'Gender': {
    'en-US': null,
    'pt-BR': 'Gênero',
    'es-ES': 'Género'
  },
  'Terms and conditions': {
    'en-US': null,
    'pt-BR': 'Termos e condições',
    'es-ES': 'Términos y condiciones'
  },
  'text_terms': {
    'en-US': 'To use Quickin, you must accept our <a href="{terms_link}" target="_blank"><strong>Terms and Conditions</strong></a> and read our <a href="{privacy_link}" target="_blank"><strong>Privacy Policy</strong></a>.',
    'pt-BR': 'Para usar o Quickin, você deve aceitar os nossos <a href="{terms_link}" target="_blank"><strong>Termos e Condições</strong></a> e ler a nossa <a href="{privacy_link}" target="_blank"><strong>Política de Privacidade</strong></a>.',
    'es-ES': 'Para utilizar Quickin, debe aceptar nuestro <a href="{terms_link}" target="_blank"><strong>Términos y condiciones</strong></a> y leer nuestro <a href="{privacy_link}" target="_ blank"><strong>Política de privacidad</strong></a>.'
  },
  'I accept the terms and conditions': {
    'en-US': null,
    'pt-BR': 'Aceito os termos e condições',
    'es-ES': 'Acepto los términos y condiciones'
  },
  'Photo': {
    'en-US': null,
    'pt-BR': 'Foto',
    'es-ES': 'Foto'
  },
  'Disability': {
    'en-US': null,
    'pt-BR': 'PcD',
    'es-ES': 'Discapacidad'
  },
  'Birth date': {
    'en-US': null,
    'pt-BR': 'Data de nascimento',
    'es-ES': 'Fecha de nacimiento'
  },
  'Qualifications summary': {
    'en-US': null,
    'pt-BR': 'Resumo das qualificações',
    'es-ES': 'Resumen de calificaciones'
  },
  'Resume (file)': {
    'en-US': null,
    'pt-BR': 'Currículo (arquivo)',
    'es-ES': 'Currículo  (archivo)'
  },
  'Salary': {
    'en-US': null,
    'pt-BR': 'Salário',
    'es-ES': 'Sueldo'
  },
  'Professional category': {
    'en-US': null,
    'pt-BR': 'Categoria profissional',
    'es-ES': 'Categoría profesional'
  },
  'Experience level': {
    'en-US': null,
    'pt-BR': 'Nível de experiência',
    'es-ES': 'Nivel de experiencia'
  },
  'Educations': {
    'en-US': null,
    'pt-BR': 'Formação',
    'es-ES': 'Educaciones'
  },
  'Last education': {
    'en-US': null,
    'pt-BR': 'Formação mínima',
    'es-ES': 'Entrenamiento mínimo'
  },
  'Experiences': {
    'en-US': null,
    'pt-BR': 'Experiências',
    'es-ES': 'Experiencias'
  },
  'Pages (Social Networks)': {
    'en-US': null,
    'pt-BR': 'Páginas (Redes sociais)',
    'es-ES': 'Páginas (Redes sociales)'
  },
  'Languages': {
    'en-US': null,
    'pt-BR': 'Idiomas',
    'es-ES': 'Idiomas'
  },
  'Language': {
    'en-US': null,
    'pt-BR': 'Idioma',
    'es-ES': 'Idioma'
  },
  'Save': {
    'en-US': null,
    'pt-BR': 'Salvar',
    'es-ES': 'Guardar'
  },
  'Cancel': {
    'en-US': null,
    'pt-BR': 'Cancelar',
    'es-ES': 'Cancelar'
  },
  'Send': {
    'en-US': null,
    'pt-BR': 'Enviar',
    'es-ES': 'Enviar'
  },
  'Send email': {
    'en-US': null,
    'pt-BR': 'Enviar e-mail',
    'es-ES': 'Enviar e-mail'
  },
  'Need approval': {
    'en-US': null,
    'pt-BR': 'Precisa de aprovação',
    'es-ES': 'Necesita aprobacion'
  },
  'There is no approval flow': {
    'en-US': null,
    'pt-BR': 'Não há fluxo de aprovação',
    'es-ES': 'No hay flujo de aprobación'
  },
  'Mine': {
    'en-US': null,
    'pt-BR': 'Minhas',
    'es-ES': 'Mi'
  },
  'All': {
    'en-US': null,
    'pt-BR': 'Todas',
    'es-ES': 'Tudo'
  },
  'New job': {
    'en-US': null,
    'pt-BR': 'Nova vaga',
    'es-ES': 'Novo trabajo'
  },
  'Clear': {
    'en-US': null,
    'pt-BR': 'Limpar',
    'es-ES': 'Limpiar'
  },
  'Find': {
    'en-US': null,
    'pt-BR': 'Encontrar',
    'es-ES': 'Buscar'
  },
  'New requisition': {
    'en-US': null,
    'pt-BR': 'Nova requisição',
    'es-ES': 'Nueva requisition'
  },
  'Openings': {
    'en-US': null,
    'pt-BR': 'Postos',
    'es-ES': 'Puestos'
  },
  'Job': {
    'en-US': null,
    'pt-BR': 'Vaga',
    'es-ES': 'Trabajo'
  },
  'Author': {
    'en-US': null,
    'pt-BR': 'Autor',
    'es-ES': 'Autor'
  },
  'Method': {
    'en-US': null,
    'pt-BR': 'Método',
    'es-ES': 'Método'
  },
  'Date': {
    'en-US': null,
    'pt-BR': 'Data',
    'es-ES': 'Fecha'
  },
  'Start date': {
    'en-US': null,
    'pt-BR': 'Data de início',
    'es-ES': 'Fecha de inicio'
  },
  'Created at': {
    'en-US': null,
    'pt-BR': 'Criado em',
    'es-ES': 'Creado en'
  },
  'Following': {
    'en-US': null,
    'pt-BR': 'Seguindo',
    'es-ES': 'Siguiente'
  },
  'Follow': {
    'en-US': null,
    'pt-BR': 'Seguir',
    'es-ES': 'Seguir'
  },
  'Create job': {
    'en-US': null,
    'pt-BR': 'Criar vaga',
    'es-ES': 'Crear trabajo'
  },
  'General information': {
    'en-US': null,
    'pt-BR': 'Informações gerais',
    'es-ES': 'Información general'
  },
  'Remuneration': {
    'en-US': null,
    'pt-BR': 'Remuneração',
    'es-ES': 'Remuneración'
  },
  'Description': {
    'en-US': null,
    'pt-BR': 'Descrição',
    'es-ES': 'Descripción'
  },
  'Requirements': {
    'en-US': null,
    'pt-BR': 'Requisitos',
    'es-ES': 'Requisitos'
  },
  'Benefits': {
    'en-US': null,
    'pt-BR': 'Benefícios',
    'es-ES': 'Beneficios'
  },
  'Comments': {
    'en-US': null,
    'pt-BR': 'Comentários',
    'es-ES': 'Comentarios'
  },
  'Control': {
    'en-US': null,
    'pt-BR': 'Controle',
    'es-ES': 'Control'
  },
  'Approval workflow': {
    'en-US': null,
    'pt-BR': 'Workflow de aprovação',
    'es-ES': 'Flujo de aprobación'
  },
  'Reset': {
    'en-US': null,
    'pt-BR': 'Redefinir',
    'es-ES': 'Reiniciar'
  },
  'Overall status': {
    'en-US': null,
    'pt-BR': 'Status geral',
    'es-ES': 'Estado general'
  },
  'Emails': {
    'en-US': null,
    'pt-BR': 'E-mails',
    'es-ES': 'E-mails'
  },
  'Received': {
    'en-US': null,
    'pt-BR': 'Recebidos',
    'es-ES': 'Recibidos'
  },
  'Sent': {
    'en-US': null,
    'pt-BR': 'Enviados',
    'es-ES': 'Enviados'
  },
  'Find email': {
    'en-US': null,
    'pt-BR': 'Encontrar e-mail',
    'es-ES': 'Buscar e-mail'
  },
  'Select an email': {
    'en-US': null,
    'pt-BR': 'Selecione um e-mail',
    'es-ES': 'Seleccione un correo electrónico'
  },
  'Notification': {
    'en-US': null,
    'pt-BR': 'Notificação',
    'es-ES': 'Notificación'
  },
  'Keywords': {
    'en-US': null,
    'pt-BR': 'Palavra-chave',
    'es-ES': 'Palabras clave'
  },
  'City': {
    'en-US': null,
    'pt-BR': 'Cidade',
    'es-ES': 'Ciudad'
  },
  'Age': {
    'en-US': null,
    'pt-BR': 'Idade',
    'es-ES': 'Edad'
  },
  'New candidate': {
    'en-US': null,
    'pt-BR': 'Novo candidato',
    'es-ES': 'Nuevo candidato'
  },
  'n_items': {
    'en-US': 'No items | <b>{count}</b> item | <b>{count}</b> items',
    'pt-BR': 'Nenhum item | <b>{count}</b> item | <b>{count}</b> itens',
    'es-ES': 'No hay ítem | <b>{count}</b> ítem | <b>{count}</b> ítems'
  },
  'Field': {
    'en-US': null,
    'pt-BR': 'Campo',
    'es-ES': 'Campo'
  },
  'Application': {
    'en-US': null,
    'pt-BR': 'Candidatura',
    'es-ES': 'Solicitud'
  },
  'Application question templates': {
    'en-US': null,
    'pt-BR': 'Templates de questões de candidatura',
    'es-ES': 'Plantillas de preguntas de aplicación'
  },
  'Application question': {
    'en-US': null,
    'pt-BR': 'Templates de questões',
    'es-ES': 'Plantillas de preguntas'
  },
  'Recommendation': {
    'en-US': null,
    'pt-BR': 'Indicação',
    'es-ES': 'Recomendación'
  },
  'Internal applied': {
    'en-US': null,
    'pt-BR': 'Aplicado internamente',
    'es-ES': 'Aplicado internamente'
  },
  'Internal application': {
    'en-US': null,
    'pt-BR': 'Aplicação interna',
    'es-ES': 'Aplicación interna'
  },
  'Conversational Agent': {
    'en-US': null,
    'pt-BR': 'Agente conversacional',
    'es-ES': 'Agente conversacional'
  },
  'Required': {
    'en-US': null,
    'pt-BR': 'Obrigatório',
    'es-ES': 'Requerido'
  },
  'Optional': {
    'en-US': null,
    'pt-BR': 'Opcional',
    'es-ES': 'Opcional'
  },
  'Disabled': {
    'en-US': null,
    'pt-BR': 'Desabilitado',
    'es-ES': 'Minusvalido'
  },
  'Open': {
    'en-US': null,
    'pt-BR': 'Aberta',
    'es-ES': 'Abierto'
  },
  'Reopen': {
    'en-US': null,
    'pt-BR': 'Reabrir',
    'es-ES': 'Reabrir'
  },
  'Archived': {
    'en-US': null,
    'pt-BR': 'Arquivada',
    'es-ES': 'Archivada'
  },
  'n_openings': {
    'en-US': '0 openings | {count} opening | {count} openings',
    'pt-BR': '0 posto | {count} posto | {count} postos',
    'es-ES': '0 trabajos | {count} trabajo | {count} trabajos'
  },
  'Number of openings': {
    'en-US': null,
    'pt-BR': 'Nº de vagas',
    'es-ES': 'Número de puestos'
  },
  'Department': {
    'en-US': null,
    'pt-BR': 'Departamento',
    'es-ES': 'Departamento'
  },
  'Country': {
    'en-US': null,
    'pt-BR': 'País',
    'es-ES': 'País'
  },
  'Currency': {
    'en-US': null,
    'pt-BR': 'Moeda',
    'es-ES': 'Divisa'
  },
  'State': {
    'en-US': null,
    'pt-BR': 'Estado',
    'es-ES': 'Estado'
  },
  'Neighborhood': {
    'en-US': null,
    'pt-BR': 'Bairro',
    'es-ES': 'Barrio'
  },
  'Address': {
    'en-US': null,
    'pt-BR': 'Endereço',
    'es-ES': 'Dirección'
  },
  'Zip code': {
    'en-US': null,
    'pt-BR': 'CEP',
    'es-ES': 'Código postal'
  },
  'Billing': {
    'en-US': null,
    'pt-BR': 'Cobrança',
    'es-ES': 'Facturación'
  },
  'Contract type': {
    'en-US': null,
    'pt-BR': 'Tipo de contratação',
    'es-ES': 'Tipo de contrato'
  },
  'Internal Comments': {
    'en-US': null,
    'pt-BR': 'Comentários internos',
    'es-ES': 'Comentarios internos'
  },
  'You can add questions to be filled in the application by the candidates.': {
    'en-US': null,
    'pt-BR': 'Você pode adicionar perguntas para serem preenchidas na candidatura pelos candidatos.',
    'es-ES': 'Puede agregar preguntas para que los candidatos las llenen en la solicitud.'
  },
  'Disqualify candidate if answer is "no"': {
    'en-US': null,
    'pt-BR': 'Desclassificar candidato caso a resposta seja "não"',
    'es-ES': 'Descalificar al candidato si la respuesta es "no"'
  },
  'Add question': {
    'en-US': null,
    'pt-BR': 'Adicionar questão',
    'es-ES': 'Agregar pregunta'
  },
  'Questions': {
    'en-US': null,
    'pt-BR': 'Questões',
    'es-ES': 'Preguntas'
  },
  'Publication': {
    'en-US': null,
    'pt-BR': 'Publicação',
    'es-ES': 'Publicación'
  },
  'Publish': {
    'en-US': null,
    'pt-BR': 'Publicar',
    'es-ES': 'Publicar'
  },
  'Unpublish': {
    'en-US': null,
    'pt-BR': 'Despublicar',
    'es-ES': 'Despublicar'
  },
  'Internal': {
    'en-US': null,
    'pt-BR': 'Interna',
    'es-ES': 'Interno'
  },
  'Don\'t publish': {
    'en-US': null,
    'pt-BR': 'Não publicar',
    'es-ES': 'No publicar'
  },
  'Scorecard templates': {
    'en-US': null,
    'pt-BR': 'Templates de scorecard',
    'es-ES': 'Plantillas de scorecard'
  },
  'Show remuneration': {
    'en-US': null,
    'pt-BR': 'Exibir remuneração',
    'es-ES': 'Mostrar remuneración'
  },
  'Show contract type': {
    'en-US': null,
    'pt-BR': 'Exibir tipo de contratação',
    'es-ES': 'Mostrar tipo de contrato'
  },
  'Show benefits': {
    'en-US': null,
    'pt-BR': 'Exibir benefícios',
    'es-ES': 'Mostrar beneficios'
  },
  'Show company description': {
    'en-US': null,
    'pt-BR': 'Exibir descrição da empresa',
    'es-ES': 'Mostrar descripción de la empresa'
  },
  'Opening date': {
    'en-US': null,
    'pt-BR': 'Data de abertura',
    'es-ES': 'Fecha de apertura'
  },
  'Expected closing date': {
    'en-US': null,
    'pt-BR': 'Previsão de fechamento',
    'es-ES': 'Fecha de cierre prevista'
  },
  'Team': {
    'en-US': null,
    'pt-BR': 'Equipe',
    'es-ES': 'Equipo'
  },
  'Restricted to team only': {
    'en-US': null,
    'pt-BR': 'Restrita apenas a equipe',
    'es-ES': 'Restringido solo para equipos'
  },
  'Qualifieds': {
    'en-US': null,
    'pt-BR': 'Classificados',
    'es-ES': 'Calificados'
  },
  'Disqualifieds': {
    'en-US': null,
    'pt-BR': 'Desclassificados',
    'es-ES': 'Descalificados'
  },
  'New': {
    'en-US': null,
    'pt-BR': 'Novo',
    'es-ES': 'Nuevo'
  },
  'Read': {
    'en-US': null,
    'pt-BR': 'Lido',
    'es-ES': 'Leer'
  },
  'Status': {
    'en-US': null,
    'pt-BR': 'Status',
    'es-ES': 'Status'
  },
  'Qualified': {
    'en-US': null,
    'pt-BR': 'Classificado',
    'es-ES': 'Calificado'
  },
  'Disqualified': {
    'en-US': null,
    'pt-BR': 'Desclassificado',
    'es-ES': 'Descalificado'
  },
  'Stage': {
    'en-US': null,
    'pt-BR': 'Etapa',
    'es-ES': 'Etapa'
  },
  'Export xlsx': {
    'en-US': null,
    'pt-BR': 'Exportar xlsx',
    'es-ES': 'Exportar xlsx'
  },
  'n_disqualified': {
    'en-US': '<strong>0</strong> disqualifieds | <strong>{count}</strong> disqualified | <strong>{count}</strong> disqualifieds',
    'pt-BR': '<strong>0</strong> desclassificados | <strong>{count}</strong> desclassificado | <strong>{count}</strong> desclassificados',
    'es-ES': '<strong>0</strong> descalificados | <strong>{count}</strong> descalificado | <strong>{count}</strong> descalificados'
  },
  'n_candidates_bold': {
    'en-US': '<strong>0</strong> candidates | <strong>{count}</strong> candidate | <strong>{count}</strong> candidates',
    'pt-BR': '<strong>0</strong> candidatos | <strong>{count}</strong> candidatos | <strong>{count}</strong> candidatos',
    'es-ES': '<strong>0</strong> candidatos | <strong>{count}</strong> candidato | <strong>{count}</strong> candidatos'
  },
  'Note': {
    'en-US': null,
    'pt-BR': 'Nota',
    'es-ES': 'Nota'
  },
  'Automatic': {
    'en-US': null,
    'pt-BR': 'Automático',
    'es-ES': 'Automático'
  },
  'To advertise on this board you need to set up the integration in Settings > Integrations.': {
    'en-US': null,
    'pt-BR': 'Para divulgar neste board é preciso configurar a integração em Configurações > Integrações.',
    'es-ES': 'Para publicar en este board es necesario configurar la integración en Configuración > Integraciones.'
  },
  'Requisition': {
    'en-US': null,
    'pt-BR': 'Requisição',
    'es-ES': 'Requisición'
  },
  'Disassociate': {
    'en-US': null,
    'pt-BR': 'Desassociar',
    'es-ES': 'Desasociar'
  },
  'Disqualify reasons': {
    'en-US': null,
    'pt-BR': 'Motivos de desclassificação',
    'es-ES': 'Motivos de descalificación'
  },
  'Cancel reasons': {
    'en-US': null,
    'pt-BR': 'Motivos de cancelamento',
    'es-ES': 'Motivos de cancelación'
  },
  'Cancel reason': {
    'en-US': null,
    'pt-BR': 'Motivo de cancelamento',
    'es-ES': 'Motivo de cancelación'
  },
  'Pipeline speed': {
    'en-US': null,
    'pt-BR': 'Velocidade da Pipeline',
    'es-ES': 'Velocidad de Pipeline'
  },
  'Pipeline conversions': {
    'en-US': null,
    'pt-BR': 'Conversões da Pipeline',
    'es-ES': 'Conversiones de Pipeline'
  },
  'Time to fill': {
    'en-US': null,
    'pt-BR': 'Tempo para preencher',
    'es-ES': 'Tiempo de llenar'
  },
  'Job details': {
    'en-US': null,
    'pt-BR': 'Detalhe de vagas',
    'es-ES': 'Detalles del trabajo'
  },
  'Current pipeline': {
    'en-US': null,
    'pt-BR': 'Pipeline atual',
    'es-ES': 'Pipeline actual'
  },
  'Hireds': {
    'en-US': null,
    'pt-BR': 'Contratados',
    'es-ES': 'Contratados'
  },
  'Candidates source': {
    'en-US': null,
    'pt-BR': 'Fonte dos candidatos',
    'es-ES': 'Fuente de candidatos'
  },
  'Advanced': {
    'en-US': null,
    'pt-BR': 'Avançado',
    'es-ES': 'Avanzado'
  },
  'Productivity': {
    'en-US': null,
    'pt-BR': 'Produtividade',
    'es-ES': 'Productividad'
  },
  'Duplicates': {
    'en-US': null,
    'pt-BR': 'Duplicados',
    'es-ES': 'Duplicados'
  },
  'merge_n_candidates': {
    'en-US': 'Merge {count} candidates | Merge {count} candidate | Merge {count} candidates',
    'pt-BR': 'Unir {count} candidatos | Unir {count} candidato | Unir {count} candidatos',
    'es-ES': 'Fusionar {count} candidatos | Fusionar {count} candidato | Fusionar {count} candidatos'
  },
  // 'openings_unfilled': {
  //   'en-US': '{count} openings not filled, reason: {reason}. | {count} opening not filled, reason: {reason}. | {count} openings not filled, reason: {reason}.',
  //   'pt-BR': '{count} postos não preenchidos, motivo: {reason}. | {count} posto não preenchido, motivo: {reason}. | {count} postos não preenchidos, motivo: {reason}.',
  //   'es-ES': '{count} puestos sin cubrir, razón: {reason}. | {count} puesto sin cubrir, razón: {reason}. | {count} puestos sin cubrir, razón: {reason}.'
  // },
  'Activities only for this job': {
    'en-US': null,
    'pt-BR': 'Atividades apenas dessa vaga',
    'es-ES': 'Actividades solo para este trabajo'
  },
  'Select job': {
    'en-US': null,
    'pt-BR': 'Selecionar vaga',
    'es-ES': 'Seleccionar trabajo'
  },
  'Subject': {
    'en-US': null,
    'pt-BR': 'Assunto',
    'es-ES': 'Sujeto'
  },
  'Templates': {
    'en-US': null,
    'pt-BR': 'Templates',
    'es-ES': 'Plantillas'
  },
  'Enter e-mails': {
    'en-US': null,
    'pt-BR': 'Informe os e-mails',
    'es-ES': 'Ingrese e-mails'
  },
  'Attach': {
    'en-US': null,
    'pt-BR': 'Anexar',
    'es-ES': 'Adjuntar'
  },
  'Location': {
    'en-US': null,
    'pt-BR': 'Local',
    'es-ES': 'Localización'
  },
  'Notify participants and guests': {
    'en-US': null,
    'pt-BR': 'Notificar participantes e convidados',
    'es-ES': 'Notificar a los participantes e invitados'
  },
  'Add guests': {
    'en-US': null,
    'pt-BR': 'Adicionar convidados',
    'es-ES': 'Agregar invitados'
  },
  'Guests': {
    'en-US': null,
    'pt-BR': 'Convidados',
    'es-ES': 'Invitados'
  },
  'Notify candidate': {
    'en-US': null,
    'pt-BR': 'Notificar candidato',
    'es-ES': 'Notificar al candidato'
  },
  'Select a scorecard': {
    'en-US': null,
    'pt-BR': 'Selecione um scorecard',
    'es-ES': 'Seleccione un scorecard'
  },
  'Task': {
    'en-US': null,
    'pt-BR': 'Tarefa',
    'es-ES': 'Tarea'
  },
  'Contact information': {
    'en-US': null,
    'pt-BR': 'Informações de contato',
    'es-ES': 'Información del contacto'
  },
  'Allow evaluation': {
    'en-US': null,
    'pt-BR': 'Permitir avaliação',
    'es-ES': 'Permitir evaluación'
  },
  'Share': {
    'en-US': null,
    'pt-BR': 'Compartilhar',
    'es-ES': 'Compartir'
  },
  'Drag or click to select files': {
    'en-US': null,
    'pt-BR': 'Arraste ou clique para selecionar os arquivos',
    'es-ES': 'Arrastra o haz clic para seleccionar archivos'
  },
  'Show': {
    'en-US': null,
    'pt-BR': 'Exibir',
    'es-ES': 'Mostrar'
  },
  'Show summary': {
    'en-US': null,
    'pt-BR': 'Exibir resumo',
    'es-ES': 'Mostrar resumen'
  },
  'Hide summary': {
    'en-US': null,
    'pt-BR': 'Ocultar resumo',
    'es-ES': 'Ocultar resumen'
  },
  'Export to PDF': {
    'en-US': null,
    'pt-BR': 'Exportar para PDF',
    'es-ES': 'Exportar a PDF'
  },
  'Export to DOCX': {
    'en-US': null,
    'pt-BR': 'Exportar para DOCX',
    'es-ES': 'Exportar a DOCX'
  },
  'Request consent': {
    'en-US': null,
    'pt-BR': 'Solicitar consentimento',
    'es-ES': 'Solicitar consentimiento'
  },
  'Needs consent': {
    'en-US': null,
    'pt-BR': 'Necessita consentimento',
    'es-ES': 'Necesita consentimiento'
  },
  'Requested consent': {
    'en-US': null,
    'pt-BR': 'Consentimento solicitado',
    'es-ES': 'Consentimiento solicitado'
  },
  'Need to remove': {
    'en-US': null,
    'pt-BR': 'Necessita remoção',
    'es-ES': 'Necesita ser eliminado'
  },
  'Expired': {
    'en-US': null,
    'pt-BR': 'Expirado',
    'es-ES': 'Caducado'
  },
  'Requested consent - Expires in {consentExpires}': {
    'en-US': 'Requested consent - Expires in {consentExpires}',
    'pt-BR': 'Consentimento solicitado - Expira em {consentExpires}',
    'es-ES': 'Consentimiento solicitado - Caduca en {consentExpires}'
  },
  'Consented - Expires in {consentExpires}': {
    'en-US': 'Consented - Expires in {consentExpires}',
    'pt-BR': 'Consentido - Expira em {consentExpires}',
    'es-ES': 'Consentimiento - Caduca el {consentExpires}'
  },
  'Expired in {consentExpires}': {
    'en-US': 'Expired in {consentExpires}',
    'pt-BR': 'Expirado em {consentExpires}',
    'es-ES': 'Caducado el {consentExpires}'
  },
  'Consented': {
    'en-US': null,
    'pt-BR': 'Consentido',
    'es-ES': 'Consentido'
  },
  'Male': {
    'en-US': null,
    'pt-BR': 'Masculino',
    'es-ES': 'Masculino'
  },
  'Female': {
    'en-US': null,
    'pt-BR': 'Feminino',
    'es-ES': 'Feminino'
  },
  'Other': {
    'en-US': null,
    'pt-BR': 'Outros',
    'es-ES': 'Otros'
  },
  'Prefer not to say': {
    'en-US': null,
    'pt-BR': 'Prefiro não dizer',
    'es-ES': 'Prefiero no decirlo'
  },
  'Search': {
    'en-US': null,
    'pt-BR': 'Buscar',
    'es-ES': 'Procurar'
  },
  'Hireds source': {
    'en-US': null,
    'pt-BR': 'Fonte dos Contratados',
    'es-ES': 'Fonte de contratados'
  },
  'Social networks': {
    'en-US': null,
    'pt-BR': 'Redes Social',
    'es-ES': 'Redes sociales'
  },
  'Job URL': {
    'en-US': null,
    'pt-BR': 'URL da vaga',
    'es-ES': 'URL de la oportunidad'
  },
  'Copy': {
    'en-US': null,
    'pt-BR': 'Copiar',
    'es-ES': 'Copiar'
  },
  'Track access': {
    'en-US': null,
    'pt-BR': 'Rastrear acesso',
    'es-ES': 'Seguimiento de acceso'
  },
  'Password': {
    'en-US': null,
    'pt-BR': 'Senha',
    'es-ES': 'Contraseña'
  },
  'New password': {
    'en-US': null,
    'pt-BR': 'Nova senha',
    'es-ES': 'Nueva contraseña'
  },
  'Confirm password': {
    'en-US': null,
    'pt-BR': 'Confirmar senha',
    'es-ES': 'Confirmar contraseña'
  },
  'Published': {
    'en-US': null,
    'pt-BR': 'Publicada',
    'es-ES': 'Publicado'
  },
  'Not published': {
    'en-US': null,
    'pt-BR': 'Não Publicada',
    'es-ES': 'No publicado'
  },
  'To add a note, select a job': {
    'en-US': null,
    'pt-BR': 'Para adicionar uma nota, selecione uma vaga',
    'es-ES': 'Para agregar una nota, seleccione un trabajo'
  },
  'To send an email, select a job': {
    'en-US': null,
    'pt-BR': 'Para enviar um e-mail, selecione uma vaga',
    'es-ES': 'Para enviar un e-mail, seleccione un trabajo'
  },
  'To add an event, select a job': {
    'en-US': null,
    'pt-BR': 'Para adicionar um agendamento, selecione uma vaga',
    'es-ES': 'Para agregar un evento, seleccione un trabajo'
  },
  'To add an evaluation, select a job': {
    'en-US': null,
    'pt-BR': 'Para adicionar uma avaliação, selecione uma vaga',
    'es-ES': 'Para agregar una evaluación, seleccione un trabajo'
  },
  'To add a task, select a job': {
    'en-US': null,
    'pt-BR': 'Para adicionar uma tarefa, selecione uma vaga',
    'es-ES': 'Para agregar una tarea, seleccione un trabajo'
  },
  'To request a video questionnaire, select a job': {
    'en-US': null,
    'pt-BR': 'Para solicitar um vídeo-questionário, selecione uma vaga',
    'es-ES': 'Para solicitar un cuestionario en video, seleccione un trabajo'
  },
  'To request a questionnaire, select a job': {
    'en-US': null,
    'pt-BR': 'Para solicitar um questionário, selecione uma vaga',
    'es-ES': 'Para solicitar un cuestionario, seleccione un trabajo'
  },
  'To share the candidate, select a job': {
    'en-US': null,
    'pt-BR': 'Para compartilhar o candidato, selecione uma vaga',
    'es-ES': 'Para compartir el candidato, seleccione un trabajo'
  },
  'To add a file, select a job': {
    'en-US': null,
    'pt-BR': 'Para adicionar um arquivo, selecione uma vaga',
    'es-ES': 'Para agregar un archivo, seleccione un trabajo'
  },
  'To export, select a job': {
    'en-US': null,
    'pt-BR': 'Para exportar, selecione uma vaga',
    'es-ES': 'Para exportar, seleccione un trabajo'
  },
  'Edit profile': {
    'en-US': null,
    'pt-BR': 'Editar perfil',
    'es-ES': 'Editar perfil'
  },
  'End editing': {
    'en-US': null,
    'pt-BR': 'Finalizar edição',
    'es-ES': 'Finalizar edición'
  },
  'Remove candidate': {
    'en-US': null,
    'pt-BR': 'Remover candidato',
    'es-ES': 'Eliminar candidato'
  },
  'n_years': {
    'en-US': '{age} years',
    'pt-BR': '{age} anos',
    'es-ES': '{age} años'
  },
  'Your approval': {
    'en-US': null,
    'pt-BR': 'Sua aprovação',
    'es-ES': 'Tu aprobación'
  },
  'Pending': {
    'en-US': null,
    'pt-BR': 'Pendente',
    'es-ES': 'Pendiente'
  },
  'Pendings': {
    'en-US': null,
    'pt-BR': 'Pendentes',
    'es-ES': 'Pendientes'
  },
  'Start flow': {
    'en-US': null,
    'pt-BR': 'Iniciar fluxo',
    'es-ES': 'Iniciar flujo'
  },
  'New flow': {
    'en-US': null,
    'pt-BR': 'Novo fluxo',
    'es-ES': 'Nuevo flujo'
  },
  'Audit': {
    'en-US': null,
    'pt-BR': 'Auditoria',
    'es-ES': 'Auditoría'
  },
  'Delete': {
    'en-US': null,
    'pt-BR': 'Deletar',
    'es-ES': 'Eliminar'
  },
  'Login': {
    'en-US': null,
    'pt-BR': 'Login',
    'es-ES': 'Login'
  },
  'Delete candidate': {
    'en-US': null,
    'pt-BR': 'Deletar candidato',
    'es-ES': 'Eliminar candidato'
  },
  'Load more': {
    'en-US': null,
    'pt-BR': 'Carregar mais',
    'es-ES': 'Carga más'
  },
  'Add review': {
    'en-US': null,
    'pt-BR': 'Adicionar avaliação',
    'es-ES': 'Agregar una evaluación'
  },
  'Edit scores': {
    'en-US': null,
    'pt-BR': 'Editar pontuação',
    'es-ES': 'Editar partitura'
  },
  'Show answers': {
    'en-US': null,
    'pt-BR': 'Exibir respostas',
    'es-ES': 'Mostrar respuestas'
  },
  'Hide answers': {
    'en-US': null,
    'pt-BR': 'Esconder respostas',
    'es-ES': 'Ocultar respuestas'
  },
  'Show history': {
    'en-US': null,
    'pt-BR': 'Exibir histórico',
    'es-ES': 'Mostrar historial'
  },
  'Hide history': {
    'en-US': null,
    'pt-BR': 'Esconder histórico',
    'es-ES': 'Ocultar historial'
  },
  'merge_n_companies': {
    'en-US': 'Merge {count} companies | Merge {count} company | Merge {count} companies',
    'pt-BR': 'Unir {count} empresas | Unir {count} empresa | Unir {count} empresas',
    'es-ES': 'Fusionar {count} empresas | Fusionar {count} empresa | Fusionar {count} empresas'
  },
  'New company': {
    'en-US': null,
    'pt-BR': 'Nova empresa',
    'es-ES': 'Nueva compañia'
  },
  'New group': {
    'en-US': null,
    'pt-BR': 'Novo grupo',
    'es-ES': 'Nuevo grupo'
  },
  'New field': {
    'en-US': null,
    'pt-BR': 'Novo campo',
    'es-ES': 'Nuevo campo'
  },
  'merge_n_departaments': {
    'en-US': 'Merge {count} departaments | Merge {count} departament | Merge {count} departaments',
    'pt-BR': 'Unir {count} departamentos | Unir {count} departamento | Unir {count} departamentos',
    'es-ES': 'Fusionar {count} departamentos | Fusionar {count} departamento | Fusionar {count} departamentos'
  },
  'New department': {
    'en-US': null,
    'pt-BR': 'Novo departamento',
    'es-ES': 'Nuevo departamento'
  },
  'Reply': {
    'en-US': null,
    'pt-BR': 'Responder',
    'es-ES': 'Respuesta'
  },
  'Reply all': {
    'en-US': null,
    'pt-BR': 'Responder todos',
    'es-ES': 'Responder a todos'
  },
  'Forward': {
    'en-US': null,
    'pt-BR': 'Encaminhar',
    'es-ES': 'Hacia adelante'
  },
  'Mark as unread': {
    'en-US': null,
    'pt-BR': 'Marcar como não lido',
    'es-ES': 'Marcar como no leído'
  },
  'Mark as read': {
    'en-US': null,
    'pt-BR': 'Marcar como lido',
    'es-ES': 'Marcar como leído'
  },
  'Enable agent': {
    'en-US': null,
    'pt-BR': 'Ativar agente',
    'es-ES': 'Activar agente'
  },
  'The conversational agent is off for this account': {
    'en-US': null,
    'pt-BR': 'O agente conversacional está desativado nesta conta',
    'es-ES': 'El agente conversacional está desactivado en esta cuenta'
  },
  'The agent is answering this conversation.': {
    'en-US': null,
    'pt-BR': 'O agente está respondendo esta conversa.',
    'es-ES': 'El agente está respondiendo esta conversación.'
  },
  'Take control': {
    'en-US': null,
    'pt-BR': 'Assumir o controle',
    'es-ES': 'Tomar el control'
  },
  'Disable agent': {
    'en-US': null,
    'pt-BR': 'Desativar agente',
    'es-ES': 'Desactivar agente'
  },
  'Setup': {
    'en-US': null,
    'pt-BR': 'Configurar',
    'es-ES': 'Configuración'
  },
  'Schedule': {
    'en-US': null,
    'pt-BR': 'Agendar',
    'es-ES': 'Programar'
  },
  'Request questionnaire': {
    'en-US': null,
    'pt-BR': 'Solicitar questionário',
    'es-ES': 'Solicitar cuestionario'
  },
  'Request video interview': {
    'en-US': null,
    'pt-BR': 'Solicitar vídeo entrevista',
    'es-ES': 'Solicitar entrevista en video'
  },
  'Request DE&I data': {
    'en-US': null,
    'pt-BR': 'Solicitar dados DE&I',
    'es-ES': 'Solicitar datos DE&I'
  },
  'Assign to job': {
    'en-US': null,
    'pt-BR': 'Associar à vaga',
    'es-ES': 'Asignar a trabajo'
  },
  'Move': {
    'en-US': null,
    'pt-BR': 'Mover',
    'es-ES': 'Mover'
  },
  'Invite new member': {
    'en-US': null,
    'pt-BR': 'Convidar novo membro',
    'es-ES': 'Invitar a un nuevo miembro'
  },
  'Invitations': {
    'en-US': null,
    'pt-BR': 'Convites',
    'es-ES': 'Invitaciones'
  },
  'Requalify': {
    'en-US': null,
    'pt-BR': 'Requalificar',
    'es-ES': 'Recalificar'
  },
  'Next': {
    'en-US': null,
    'pt-BR': 'Próximo',
    'es-ES': 'Próximo'
  },
  'Request': {
    'en-US': null,
    'pt-BR': 'Solicitar',
    'es-ES': 'Solicitar'
  },
  'New member': {
    'en-US': null,
    'pt-BR': 'Novo membro',
    'es-ES': 'Nuevo miembro'
  },
  'Yes': {
    'en-US': null,
    'pt-BR': 'Sim',
    'es-ES': 'Sí'
  },
  'No': {
    'en-US': null,
    'pt-BR': 'Não',
    'es-ES': 'No'
  },
  'New questionnaire': {
    'en-US': null,
    'pt-BR': 'Novo questionário',
    'es-ES': 'Nuevo cuestionario'
  },
  'merge_n_sources': {
    'en-US': 'Merge {count} sources | Merge {count} source | Merge {count} sources',
    'pt-BR': 'Unir {count} fontes | Unir {count} fonte | Unir {count} fontes',
    'es-ES': 'Fusionar {count} fuentes | Fusionar {count} fuente | Fusionar {count} fuentes'
  },
  'merge_n_tags': {
    'en-US': 'Merge {count} tags | Merge {count} tag | Merge {count} tags',
    'pt-BR': 'Unir {count} tags | Unir {count} tag | Unir {count} tags',
    'es-ES': 'Fusionar {count} etiquetas | Fusionar {count} etiqueta | Fusionar {count} etiquetas'
  },
  'merge_n_items': {
    'en-US': 'Merge {count} items | Merge {count} item | Merge {count} items',
    'pt-BR': 'Unir {count} itens | Unir {count} item | Unir {count} itens',
    'es-ES': 'Fusionar {count} ítems | Fusionar {count} ítem | Fusionar {count} ítem'
  },
  'New video form': {
    'en-US': null,
    'pt-BR': 'Novo vídeo formulário',
    'es-ES': 'Nuevo formulario de video'
  },
  'Resend': {
    'en-US': null,
    'pt-BR': 'Reenviar',
    'es-ES': 'Reenviar'
  },
  'Degree': {
    'en-US': null,
    'pt-BR': 'Grau',
    'es-ES': 'Grado'
  },
  'Course': {
    'en-US': null,
    'pt-BR': 'Curso',
    'es-ES': 'Curso'
  },
  'Institution': {
    'en-US': null,
    'pt-BR': 'Instituição',
    'es-ES': 'Instituición'
  },
  'Period': {
    'en-US': null,
    'pt-BR': 'Período',
    'es-ES': 'Periodo'
  },
  'Education degree': {
    'en-US': null,
    'pt-BR': 'Nível escolaridade',
    'es-ES': 'Nivel educativo'
  },
  'GDPT Compliance': {
    'en-US': null,
    'pt-BR': 'LGPD Compliance',
    'es-ES': 'Cumplimiento de GDPT'
  },
  'n_candidates': {
    'en-US': '{count} candidates | {count} candidate | {count} candidates',
    'pt-BR': '{count} candidatos | {count} candidato | {count} candidatos',
    'es-ES': '{count} candidatos | {count} candidato | {count} candidatos'
  },
  'Add item': {
    'en-US': null,
    'pt-BR': 'Adicionar item',
    'es-ES': 'Agregar ítem'
  },
  'correct_timezone': {
    'en-US': 'It looks like your correct timezone is "<strong>{browserTimezone}</strong>"',
    'pt-BR': 'Parece que o sua timezone correta é "<strong>{browserTimezone}</strong>"',
    'es-ES': 'Parece que tu zona horaria correcta es "<strong>{browserTimezone}</strong>'
  },
  'Update': {
    'en-US': null,
    'pt-BR': 'Atualizar',
    'es-ES': 'Actualizar'
  },
  'Resend invitation': {
    'en-US': null,
    'pt-BR': 'Reenviar convite',
    'es-ES': 'Reenviar invitación'
  },
  'Preview': {
    'en-US': null,
    'pt-BR': 'Pré-visualizar',
    'es-ES': 'Vista previa'
  },
  'Add': {
    'en-US': null,
    'pt-BR': 'Adicionar',
    'es-ES': 'Agregar'
  },
  'View page': {
    'en-US': null,
    'pt-BR': 'Visualizar página',
    'es-ES': 'Ver página'
  },
  'Edit page': {
    'en-US': null,
    'pt-BR': 'Editar página',
    'es-ES': 'Editar página'
  },
  'Extract resume data': {
    'en-US': null,
    'pt-BR': 'Extrair dados do currículo',
    'es-ES': 'Extraer datos del resumen'
  },
  'Add company': {
    'en-US': null,
    'pt-BR': 'Adicionar empresa',
    'es-ES': 'Agregar empresa'
  },
  'Add education': {
    'en-US': null,
    'pt-BR': 'Adicionar formação',
    'es-ES': 'Agregar formación'
  },
  'Add phone': {
    'en-US': null,
    'pt-BR': 'Adicionar telefone',
    'es-ES': 'Agregar teléfono'
  },
  'Show less': {
    'en-US': null,
    'pt-BR': 'Exibir menos',
    'es-ES': 'Mostrar menos'
  },
  'Show more': {
    'en-US': null,
    'pt-BR': 'Exibir mais',
    'es-ES': 'Mostrar más'
  },
  'Privacy Policy': {
    'en-US': null,
    'pt-BR': 'Política de privacidade',
    'es-ES': 'Política de privacidad'
  },
  'Add group': {
    'en-US': null,
    'pt-BR': 'Adicionar grupo',
    'es-ES': 'Añadir grupo'
  },
  'Group': {
    'en-US': null,
    'pt-BR': 'Grupo',
    'es-ES': 'Grupo'
  },
  'All companies': {
    'en-US': null,
    'pt-BR': 'Todas as empresas',
    'es-ES': 'Todas las empresas'
  },
  'All departments': {
    'en-US': null,
    'pt-BR': 'Todos os departamentos',
    'es-ES': 'Todos los departamentos'
  },
  'see_Privacy_notice_model': {
    'en-US': 'See a <a href="https://intercom.help/quickin/pt-BR/articles/4515566-model-de-aviso-de-privicidade-de-recrutamento" target="_blank">model</a> Privacy Notice',
    'pt-BR': 'Veja um <a href="https://intercom.help/quickin/pt-BR/articles/4515566-modelo-de-aviso-de-privacidade-de-recrutamento" target="_blank">modelo</a> de Aviso de Privacidade',
    'es-ES': 'Ver un <a href="https://intercom.help/quickin/pt-BR/articles/4515566-model-de-aviso-de-privicidade-de-recrutamento" target="_blank">modelo</a> del Aviso de privacidad'
  },
  'Add domain': {
    'en-US': null,
    'pt-BR': 'Adicionar domínio',
    'es-ES': 'Agregar dominio'
  },
  'Correct': {
    'en-US': null,
    'pt-BR': 'Correta',
    'es-ES': 'Correcto'
  },
  'Incomplete': {
    'en-US': null,
    'pt-BR': 'Incompleto',
    'es-ES': 'Incompleto'
  },
  'The password has been successfully reset!': {
    'en-US': null,
    'pt-BR': 'A senha foi redefinida com sucesso!',
    'es-ES': '¡Contraseña restablecida correctamente!'
  },
  'You will be redirected to the login page.': {
    'en-US': null,
    'pt-BR': 'Você será redirecionado para a página de login.',
    'es-ES': 'Serás redirigido a la página de login.'
  },
  'Wait...': {
    'en-US': null,
    'pt-BR': 'Aguarde...',
    'es-ES': 'Espera...'
  },
  'Email template': {
    'en-US': null,
    'pt-BR': 'Template de e-mail',
    'es-ES': 'Plantilla de e-mail'
  },
  'Duration': {
    'en-US': null,
    'pt-BR': 'Duração',
    'es-ES': 'Duración'
  },
  'Type': {
    'en-US': null,
    'pt-BR': 'Tipo',
    'es-ES': 'Tipo'
  },
  'Participants': {
    'en-US': null,
    'pt-BR': 'Participantes',
    'es-ES': 'Participantes'
  },
  'Show transcription': {
    'en-US': null,
    'pt-BR': 'Exibir transcrição',
    'es-ES': 'Mostrar transcripción'
  },
  'Hide transcription': {
    'en-US': null,
    'pt-BR': 'Ocultar transcrição',
    'es-ES': 'Ocultar transcripción'
  },
  'n_shared_candidates': {
    'en-US': '{count} shared candidates | {count} shared candidate | {count} shared candidates',
    'pt-BR': '{count} candidatos compartilhados | {count} candidato compartilhado | {count} candidatos compartilhados',
    'es-ES': '{count} candidatos compartidos | {count} candidato compartido | {count} candidatos compartidos'
  },
  'n_actions': {
    'en-US': '{count} actions | {count} action | {count} actions',
    'pt-BR': '{count} ações | {count} ação | {count} ações',
    'es-ES': '{count} acciónes | {count} acción | {count} acciónes'
  },
  'Actions': {
    'en-US': null,
    'pt-BR': 'Ações',
    'es-ES': 'Acciónes'
  },
  'Add action': {
    'en-US': null,
    'pt-BR': 'Adicionar ação',
    'es-ES': 'Añadir acción'
  },
  'Add actions': {
    'en-US': null,
    'pt-BR': 'Adicionar ações',
    'es-ES': 'Añadir acciónes'
  },
  'Year': {
    'en-US': null,
    'pt-BR': 'Ano',
    'es-ES': 'Año'
  },
  'Month': {
    'en-US': null,
    'pt-BR': 'Mês',
    'es-ES': 'Mes'
  },
  'Hour': {
    'en-US': null,
    'pt-BR': 'Hora',
    'es-ES': 'Hora'
  },
  'From': {
    'en-US': null,
    'pt-BR': 'De',
    'es-ES': 'De'
  },
  'To': {
    'en-US': null,
    'pt-BR': 'Até',
    'es-ES': 'A'
  },
  'Per': {
    'en-US': null,
    'pt-BR': 'Por',
    'es-ES': 'Per'
  },
  'Mentioned in a note': {
    'en-US': null,
    'pt-BR': 'Mencionado em uma nota',
    'es-ES': 'Mencionado en una nota'
  },
  'New share': {
    'en-US': null,
    'pt-BR': 'Novo compartilhamento',
    'es-ES': 'Nuevo recurso compartido'
  },
  'New evaluation': {
    'en-US': null,
    'pt-BR': 'Nova avaliação',
    'es-ES': 'Nueva evaluación'
  },
  'Questionnaire answered': {
    'en-US': null,
    'pt-BR': 'Questionário respondido',
    'es-ES': 'Cuestionario respondido'
  },
  'Video interview answered': {
    'en-US': null,
    'pt-BR': 'Vídeo entrevista respondido',
    'es-ES': 'Video entrevista respondida'
  },
  'Task reminder': {
    'en-US': null,
    'pt-BR': 'Lembrete de tarefa',
    'es-ES': 'Recordatorio de tareas'
  },
  'Finalizing the requisition approval workflow': {
    'en-US': null,
    'pt-BR': 'Finalização do workflow de aprovação de requisição',
    'es-ES': 'Finalización del flujo de trabajo de aprobación de solicitudes'
  },
  'New note': {
    'en-US': null,
    'pt-BR': 'Nova nota',
    'es-ES': 'Nueva nota'
  },
  'Candidate requalified': {
    'en-US': null,
    'pt-BR': 'Candidato requalificado',
    'es-ES': 'Candidato recalificado'
  },
  'Disqualified candidate': {
    'en-US': null,
    'pt-BR': 'Candidato desclassificado',
    'es-ES': 'Candidato descalificado'
  },
  'Note added to job': {
    'en-US': null,
    'pt-BR': 'Nota adicionada à vaga',
    'es-ES': 'Nota agregada al trabajo'
  },
  'Email': {
    'en-US': null,
    'pt-BR': 'E-mail',
    'es-ES': 'E-mail'
  },
  'Select image': {
    'en-US': null,
    'pt-BR': 'Selecionar imagem',
    'es-ES': 'Seleccionar imagen'
  },
  'Click on "Add extension" of the alert.': {
    'en-US': null,
    'pt-BR': 'Clique em "Adicionar extensão" do alerta.',
    'es-ES': 'Haga clic en "Agregar extensión" para alertar.'
  },
  'Click on "Use no Chrome"': {
    'en-US': null,
    'pt-BR': 'Clique em "Usar no Chrome"',
    'es-ES': 'Haz clic en "Usar no Chrome"'
  },
  'Extension for Google Chrome': {
    'en-US': null,
    'pt-BR': 'Extensão para o Google Chrome',
    'es-ES': 'Extensión para Google Chrome'
  },
  'Install it in Chrome using the link below:': {
    'en-US': null,
    'pt-BR': 'Faça a instalação no Chrome pelo link abaixo:',
    'es-ES': 'Para instalar Chrome en el siguiente enlace:'
  },
  'Importing or profile': {
    'en-US': null,
    'pt-BR': 'Importando o perfil',
    'es-ES': 'Importando el perfil'
  },
  'Installing the extension in Chrome': {
    'en-US': null,
    'pt-BR': 'Instalando a extensão no Chrome',
    'es-ES': 'Instalación de una extensión en Chrome'
  },
  'Go to the page of a candidate on the site that you want to import.': {
    'en-US': null,
    'pt-BR': 'Vá para página de um candidato no site que deseja fazer a importação.',
    'es-ES': 'Vá para la página de un candidato no sitio que desee hacer a importación.'
  },
  'Phones': {
    'en-US': null,
    'pt-BR': 'Telefones',
    'es-ES': 'Teléfonos'
  },
  'Phone': {
    'en-US': null,
    'pt-BR': 'Telefone',
    'es-ES': 'Teléfono'
  },
  'Question': {
    'en-US': null,
    'pt-BR': 'Questão',
    'es-ES': 'Pregunta'
  },
  'Answers': {
    'en-US': null,
    'pt-BR': 'Respostas',
    'es-ES': 'Respuestas'
  },
  'Answer': {
    'en-US': null,
    'pt-BR': 'Resposta',
    'es-ES': 'Respuesta'
  },
  'Message': {
    'en-US': null,
    'pt-BR': 'Mensagem',
    'es-ES': 'Mensaje'
  },
  'Disqualification': {
    'en-US': null,
    'pt-BR': 'Desqualificação',
    'es-ES': 'Descalificación'
  },
  'Select a quentionnaire': {
    'en-US': null,
    'pt-BR': 'Selecione um questionário',
    'es-ES': 'Seleccione un cuestionario'
  },
  'Select a video form': {
    'en-US': null,
    'pt-BR': 'Selecione um vídeo formulário',
    'es-ES': 'Seleccione un formulario de video'
  },
  'Find requisition': {
    'en-US': null,
    'pt-BR': 'Encontrar requisição',
    'es-ES': 'Buscar requisición'
  },
  'Find job': {
    'en-US': null,
    'pt-BR': 'Encontrar vaga',
    'es-ES': 'Encuentra trabajo'
  },
  'Enter email': {
    'en-US': null,
    'pt-BR': 'Informe o e-mail',
    'es-ES': 'Ingrese e-mail'
  },
  'Alternative': {
    'en-US': null,
    'pt-BR': 'Alternativa',
    'es-ES': 'Alternativa'
  },
  'Source': {
    'en-US': null,
    'pt-BR': 'Fonte',
    'es-ES': 'Fuente'
  },
  'URL': {
    'en-US': null,
    'pt-BR': 'URL',
    'es-ES': 'URL'
  },
  'End date': {
    'en-US': null,
    'pt-BR': 'Data término',
    'es-ES': 'Fecha final'
  },
  'Address, Number, Complement': {
    'en-US': null,
    'pt-BR': 'Endereço, Número, Complemento',
    'es-ES': 'Dirección, Número, Complemento'
  },
  'Note. Use @ to mention someone.': {
    'en-US': null,
    'pt-BR': 'Nota. Use o @ para mencionar alguém.',
    'es-ES': 'Nota. Utilice @ para mencionar a alguien.'
  },
  'Comment': {
    'en-US': null,
    'pt-BR': 'Comentário',
    'es-ES': 'Comentario'
  },
  'Days': {
    'en-US': null,
    'pt-BR': 'Dias',
    'es-ES': 'Dias'
  },
  'Select a date': {
    'en-US': null,
    'pt-BR': 'Selecione uma data',
    'es-ES': 'Seleccionar una fecha'
  },
  'Phone interview': {
    'en-US': null,
    'pt-BR': 'Entrevista por telefone',
    'es-ES': 'Entrevista por telefono'
  },
  'Video interview': {
    'en-US': null,
    'pt-BR': 'Entrevista por vídeo',
    'es-ES': 'Entrevista en video'
  },
  'On site': {
    'en-US': null,
    'pt-BR': 'No local',
    'es-ES': 'En el sitio'
  },
  'Assign to new job': {
    'en-US': null,
    'pt-BR': 'Associar à nova vaga',
    'es-ES': 'Asignar a un nuevo trabajo'
  },
  'Date of birth': {
    'en-US': null,
    'pt-BR': 'Data de nascimento',
    'es-ES': 'Fecha de nacimiento'
  },
  'Hearing': {
    'en-US': null,
    'pt-BR': 'Auditivo',
    'es-ES': 'Auditivo'
  },
  'Visual': {
    'en-US': null,
    'pt-BR': 'Visual',
    'es-ES': 'Visual'
  },
  'Intellectual': {
    'en-US': null,
    'pt-BR': 'Intelectual',
    'es-ES': 'Intelectual'
  },
  'Physical': {
    'en-US': null,
    'pt-BR': 'Físico',
    'es-ES': 'Físico'
  },
  'Add language': {
    'en-US': null,
    'pt-BR': 'Adicionar idioma',
    'es-ES': 'Agregar idioma'
  },
  'Stopped': {
    'en-US': null,
    'pt-BR': 'Parado',
    'es-ES': 'Detenido'
  },
  'Approved': {
    'en-US': null,
    'pt-BR': 'Aprovado',
    'es-ES': 'Aprobada'
  },
  'Disapproved': {
    'en-US': null,
    'pt-BR': 'Reprovado',
    'es-ES': 'Desaprobada'
  },
  'n_approvals_required': {
    'en-US': '{count} approvals required | {count} approval required | {count} approvals required',
    'pt-BR': '{count} aprovações necessárias | {count} aprovação necessárias | {count} aprovações necessárias',
    'es-ES': '{count} aprobaciones requeridas | {count} aprobación requerida | {count} aprobaciones requeridas'
  },
  'Completed': {
    'en-US': null,
    'pt-BR': 'Concluído',
    'es-ES': 'Terminado'
  },
  'Deadline': {
    'en-US': null,
    'pt-BR': 'Prazo',
    'es-ES': 'Plazo'
  },
  'Last hired': {
    'en-US': null,
    'pt-BR': 'Último contratado',
    'es-ES': 'Contratado por última vez'
  },
  'Time/Deadline': {
    'en-US': null,
    'pt-BR': 'Tempo/Prazo',
    'es-ES': 'Hora / Plazo'
  },
  'Maximum remuneration': {
    'en-US': null,
    'pt-BR': 'Remuneração máxima',
    'es-ES': 'Remuneración máxima'
  },
  'Remuneration period': {
    'en-US': null,
    'pt-BR': 'Remuneração período',
    'es-ES': 'Período de remuneración'
  },
  'Contract': {
    'en-US': null,
    'pt-BR': 'Contrato',
    'es-ES': 'Contrato'
  },
  'Default': {
    'en-US': null,
    'pt-BR': 'Padrão',
    'es-ES': 'Predeterminado'
  },
  'Role': {
    'en-US': null,
    'pt-BR': 'Função',
    'es-ES': 'Papel'
  },
  'Active': {
    'en-US': null,
    'pt-BR': 'Ativo',
    'es-ES': 'Activo'
  },
  'Inactive': {
    'en-US': null,
    'pt-BR': 'Inativo',
    'es-ES': 'Inativo'
  },
  'Processing': {
    'en-US': null,
    'pt-BR': 'Processando',
    'es-ES': 'Procesando'
  },
  'Gerar preset com IA': {
    'en-US': 'Generate preset with AI',
    'pt-BR': null,
    'es-ES': 'Generar preset con IA'
  },
  'A IA usa o site, as redes sociais, o logo, as fotos e as informações da empresa para montar o site de carreiras automaticamente.': {
    'en-US': 'AI uses the company website, social networks, logo, photos and company information to build the career site automatically.',
    'pt-BR': null,
    'es-ES': 'La IA usa el sitio web, las redes sociales, el logo, las fotos y la información de la empresa para crear el sitio de carreras automáticamente.'
  },
  'Presença online': {
    'en-US': 'Online presence',
    'pt-BR': null,
    'es-ES': 'Presencia online'
  },
  'Site da empresa': {
    'en-US': 'Company website',
    'pt-BR': null,
    'es-ES': 'Sitio web de la empresa'
  },
  'Outros sites': {
    'en-US': 'Other websites',
    'pt-BR': null,
    'es-ES': 'Otros sitios'
  },
  'Adicionar site': {
    'en-US': 'Add website',
    'pt-BR': null,
    'es-ES': 'Agregar sitio'
  },
  'Identidade visual': {
    'en-US': 'Visual identity',
    'pt-BR': null,
    'es-ES': 'Identidad visual'
  },
  'Logo': {
    'en-US': null,
    'pt-BR': null,
    'es-ES': null
  },
  'Selecionar logo': {
    'en-US': 'Select logo',
    'pt-BR': null,
    'es-ES': 'Seleccionar logo'
  },
  'Fotos': {
    'en-US': 'Photos',
    'pt-BR': null,
    'es-ES': 'Fotos'
  },
  'Informações da empresa': {
    'en-US': 'Company information',
    'pt-BR': null,
    'es-ES': 'Información de la empresa'
  },
  'As informações aqui são usadas pela IA para montar as seções do site de carreiras (benefícios, cultura, depoimentos, unidades, etc.).': {
    'en-US': 'The information here is used by AI to build the career site sections (benefits, culture, testimonials, locations, etc.).',
    'pt-BR': null,
    'es-ES': 'La información aquí es usada por la IA para crear las secciones del sitio de carreras (beneficios, cultura, testimonios, unidades, etc.).'
  },
  'Gerar e salvar': {
    'en-US': 'Generate and save',
    'pt-BR': null,
    'es-ES': 'Generar y guardar'
  },
  'New site': {
    'en-US': null,
    'pt-BR': 'Novo site',
    'es-ES': 'Nuevo sitio'
  },
  'Ativar': {
    'en-US': 'Activate',
    'pt-BR': null,
    'es-ES': 'Activar'
  },
  'Desativar': {
    'en-US': 'Deactivate',
    'pt-BR': null,
    'es-ES': 'Desactivar'
  },
  'Error': {
    'en-US': null,
    'pt-BR': 'Erro',
    'es-ES': 'Error'
  },
  'Candidate': {
    'en-US': null,
    'pt-BR': 'Candidato',
    'es-ES': 'Candidato'
  },
  'Defaut currency': {
    'en-US': null,
    'pt-BR': 'Moeda padrão',
    'es-ES': 'Moneda predeterminada'
  },
  'Average number of days in the stage': {
    'en-US': null,
    'pt-BR': 'Média de dias na etapa',
    'es-ES': 'Número medio de días en la etapa'
  },
  'Generate job description (ChatGPT)': {
    'en-US': null,
    'pt-BR': 'Gerar job description (ChatGPT)',
    'es-ES': 'Generar descripción del trabajo (ChatGPT)'
  },
  'Short text': {
    'en-US': null,
    'pt-BR': 'Texto curto',
    'es-ES': 'Texto corto'
  },
  'Long text': {
    'en-US': null,
    'pt-BR': 'Texto longo',
    'es-ES': 'Texto largo'
  },
  'List of options (Single choice)': {
    'en-US': null,
    'pt-BR': 'Lista de opções (Única escolha)',
    'es-ES': 'Lista de opciones (Elección única)'
  },
  'List of options (Multiple choice)': {
    'en-US': null,
    'pt-BR': 'Lista de opções (Múltipla escolha)',
    'es-ES': 'Lista de opciones (Selección múltiple)'
  },
  'Yes or no': {
    'en-US': null,
    'pt-BR': 'Sim ou não',
    'es-ES': 'Sí o no'
  },
  'Salary Expectation': {
    'en-US': null,
    'pt-BR': 'Pretensão Salarial',
    'es-ES': 'Expectativa Salarial'
  },
  'Attributions': {
    'en-US': null,
    'pt-BR': 'Atribuições',
    'es-ES': 'Atribuciones'
  },
  'New tag': {
    'en-US': null,
    'pt-BR': 'Nova tag',
    'es-ES': 'Nueva etiqueta'
  },
  'Basic': {
    'en-US': null,
    'pt-BR': 'Básico',
    'es-ES': 'Básico'
  },
  'Fluent': {
    'en-US': null,
    'pt-BR': 'Fluente',
    'es-ES': 'Fluyente'
  },
  'New source': {
    'en-US': null,
    'pt-BR': 'Nova fonte',
    'es-ES': 'Nueva fuente'
  },
  'New description': {
    'en-US': null,
    'pt-BR': 'Nova descrição',
    'es-ES': 'Nueva descripción'
  },
  'New two-factor verification recovery password.': {
    'en-US': null,
    'pt-BR': 'Nova senha de recuperação de verificação de duas etapas.',
    'es-ES': 'Nueva contraseña de recuperación de verificación de dos pasos.'
  },
  'Send when': {
    'en-US': null,
    'pt-BR': 'Enviar quando',
    'es-ES': 'Enviar cuando'
  },
  'Candidate in the job': {
    'en-US': null,
    'pt-BR': 'Candidato na vaga',
    'es-ES': 'Candidato en el trabajo'
  },
  'Hired candidate': {
    'en-US': null,
    'pt-BR': 'Candidato contratado',
    'es-ES': 'Candidato contratado'
  },
  'Job pipeline': {
    'en-US': null,
    'pt-BR': 'Pipeline da vaga',
    'es-ES': 'Pipeline de lo trabajo'
  },
  'Great': {
    'en-US': null,
    'pt-BR': 'Excelente',
    'es-ES': 'Excelente'
  },
  'Good': {
    'en-US': null,
    'pt-BR': 'Bom',
    'es-ES': 'Bien'
  },
  'Average': {
    'en-US': null,
    'pt-BR': 'Médio',
    'es-ES': 'Promedio'
  },
  'Inappropriate': {
    'en-US': null,
    'pt-BR': 'Inadequado',
    'es-ES': 'Inadecuado'
  },
  'Expires in': {
    'en-US': null,
    'pt-BR': 'Expira em',
    'es-ES': 'Exhala'
  },
  'Pipeline': {
    'en-US': null,
    'pt-BR': 'Pipeline',
    'es-ES': 'Pipeline'
  },
  'Referrals': {
    'en-US': null,
    'pt-BR': 'Indicações',
    'es-ES': 'Recomendaciones'
  },
  'Candidates overview': {
    'en-US': null,
    'pt-BR': 'Candidatos overview',
    'es-ES': 'Candidatos overview'
  },
  'Jobs overview': {
    'en-US': null,
    'pt-BR': 'Vagas overview',
    'es-ES': 'Trabajos overview'
  },
  'Performance': {
    'en-US': null,
    'pt-BR': 'Desempenho',
    'es-ES': 'actuación'
  },
  'Reports 1.0': {
    'en-US': null,
    'pt-BR': 'Relatórios 1.0',
    'es-ES': 'Informes 1.0'
  },
  'n_records': {
    'en-US': 'No records | <b>{count}</b> record | <b>{count}</b> records',
    'pt-BR': 'Nenhum registro | <b>{count}</b> registro | <b>{count}</b> registros',
    'es-ES': 'No hay registro | <b>{count}</b> registro | <b>{count}</b> registros'
  },
  'Keep your account safe and secure by regularly changing passwords.': {
    'en-US': null,
    'pt-BR': 'Mantenha sua conta segura e protegida através da troca regular de senhas.',
    'es-ES': 'Mantenga su cuenta segura cambiando las contraseñas periódicamente.'
  },
  'Manage connected devices': {
    'en-US': null,
    'pt-BR': 'Gerenciar dispositivos conectados',
    'es-ES': 'Administrar dispositivos conectados'
  },
  'View and manage all devices currently connected to your account. Revoke access from unauthorized devices and maintain full control of access.': {
    'en-US': null,
    'pt-BR': 'Visualize e gerencie todos os dispositivos atualmente conectados à sua conta. Revogue o acesso de dispositivos não autorizados e mantenha controle total dos acessos.',
    'es-ES': 'Vea y administre todos los dispositivos actualmente conectados a su cuenta. Revocar el acceso desde dispositivos no autorizados y mantener el control total del acceso.'
  },
  'Enable 2-step verification': {
    'en-US': null,
    'pt-BR': 'Ative a verificação em 2 etapas',
    'es-ES': 'Habilite la verificación en dos pasos'
  },
  'Connected devices': {
    'en-US': null,
    'pt-BR': 'Dispositivos conectados',
    'es-ES': 'Dispositivos conectados'
  },
  'Device': {
    'en-US': null,
    'pt-BR': 'Dispositivo',
    'es-ES': 'Dispositivo'
  },
  'IP': {
    'en-US': null,
    'pt-BR': 'IP',
    'es-ES': 'empresario individual'
  },
  'Last acess': {
    'en-US': null,
    'pt-BR': 'Último acesso',
    'es-ES': 'Ultimo acceso'
  },
  'Generated in': {
    'en-US': null,
    'pt-BR': 'Gerado em',
    'es-ES': 'Generado en'
  },
  'Disconnect': {
    'en-US': null,
    'pt-BR': 'Desconectar',
    'es-ES': 'Desconectar'
  },
  'This device': {
    'en-US': null,
    'pt-BR': 'Este dispositivo',
    'es-ES': 'Este dispositivo'
  },
  'Automatically unify': {
    'en-US': null,
    'pt-BR': 'Unificar automaticamente',
    'es-ES': 'Unificar automáticamente'
  },
  'Merge new applications with existing profiles automatically.': {
    'en-US': null,
    'pt-BR': 'Unir novas candidaturas com perfis já existentes automaticamente.',
    'es-ES': 'Fusionar nuevas aplicaciones con perfiles existentes automáticamente.'
  },
  'View': {
    'en-US': null,
    'pt-BR': 'Visualizar',
    'es-ES': 'Visualizar'
  },
  'New page': {
    'en-US': null,
    'pt-BR': 'Nova página',
    'es-ES': 'Nueva página'
  },
  'View all job (non-confidential) and requisitions': {
    'en-US': null,
    'pt-BR': 'Visualizar todas as vagas (não confidenciais) e requisições',
    'es-ES': 'Ver todas los trabajos (no confidenciales) y requisiciones'
  },
  'View all confidential jobs and requisitions': {
    'en-US': null,
    'pt-BR': 'Visualizar todas as vagas confidenciais e requisições',
    'es-ES': 'Ver todas los trabajos confidenciales y requisiciones'
  },
  'Create/edit requisitions': {
    'en-US': null,
    'pt-BR': 'Criar/editar requisições',
    'es-ES': 'Crear/editar requisiciones'
  },
  'Create/edit jobs': {
    'en-US': null,
    'pt-BR': 'Criar/editar vagas',
    'es-ES': 'Crear/editar trabajos'
  },
  'Manage, move, schedule, share candidates': {
    'en-US': null,
    'pt-BR': 'Gerenciar, mover, agendar, compartilhar candidatos',
    'es-ES': 'Gestionar, mover, programar, compartir candidatos'
  },
  'Publish jobs': {
    'en-US': null,
    'pt-BR': 'Divulgar vagas',
    'es-ES': 'Publicar trabajos'
  },
  'View basic reports': {
    'en-US': null,
    'pt-BR': 'Ver relatórios básicos',
    'es-ES': 'Ver informes básicos'
  },
  'View advanced reports': {
    'en-US': null,
    'pt-BR': 'Ver relatórios avançados',
    'es-ES': 'Ver informes avanzados'
  },
  'Manage career pages': {
    'en-US': null,
    'pt-BR': 'Gerenciar páginas de carreiras',
    'es-ES': 'Administrar páginas de carrera'
  },
  'Manage companies': {
    'en-US': null,
    'pt-BR': 'Gerenciar empresas',
    'es-ES': 'Gestionar empresas'
  },
  'Manage departments': {
    'en-US': null,
    'pt-BR': 'Gerenciar departamentos',
    'es-ES': 'Gestionar departamentos'
  },
  'Manage members and permissions': {
    'en-US': null,
    'pt-BR': 'Gerenciar membros e permissões',
    'es-ES': 'Administrar miembros y permisos'
  },
  'Manage other settings such as tags, contracts, cancellation reasons...': {
    'en-US': null,
    'pt-BR': 'Gerenciar outras configurações como tags, contratos, motivos de cancelamento...',
    'es-ES': 'Gestionar otras configuraciones como etiquetas, contratos, motivos de cancelación...'
  },
  'Manage billing': {
    'en-US': null,
    'pt-BR': 'Gerenciar cobrança',
    'es-ES': 'Gestionar facturación'
  },
  'Main': {
    'en-US': null,
    'pt-BR': 'Principal',
    'es-ES': 'Principal'
  },
  'Flow': {
    'en-US': null,
    'pt-BR': 'Fluxo',
    'es-ES': 'Flujo'
  },
  'Approvers': {
    'en-US': null,
    'pt-BR': 'Aprovadores',
    'es-ES': 'Aprobadores'
  },
  'Necessary': {
    'en-US': null,
    'pt-BR': 'Necessários',
    'es-ES': 'Necesario'
  },
  'Expiration': {
    'en-US': null,
    'pt-BR': 'Expiração',
    'es-ES': 'Vencimiento'
  },
  'Enable GDPR': {
    'en-US': null,
    'pt-BR': 'Habilitar LGPD',
    'es-ES': 'Habilitar GDPR'
  },
  'Diversity': {
    'en-US': null,
    'pt-BR': 'Diversidade',
    'es-ES': 'Diversidad'
  },
  'GDPR': {
    'en-US': null,
    'pt-BR': 'LGPD',
    'es-ES': 'GDPR'
  },
  'View features and settings for GDPR related': {
    'en-US': null,
    'pt-BR': 'Exibir recursos e configurações para relacionados a LGPD',
    'es-ES': 'Ver funciones y configuraciones relacionadas con GDPR'
  },
  'Unsubscribe link': {
    'en-US': null,
    'pt-BR': 'Link de descadastramento',
    'es-ES': 'Link de desuscripción'
  },
  '(Automatic) Adds a footer with an unsubscribe link to the application confirmation email.': {
    'en-US': null,
    'pt-BR': '(Automático) Adiciona ao e-mail de confirmação de candidatura um rodapé com link de descadastramento.',
    'es-ES': '(Automático) Agrega un pie de página con un enlace de desuscripción al correo de confirmación de solicitud de trabajo.'
  },
  'Privacy notice': {
    'en-US': null,
    'pt-BR': 'Aviso de privacidade',
    'es-ES': 'Aviso de privacidad'
  },
  'Consent': {
    'en-US': null,
    'pt-BR': 'Consentimento',
    'es-ES': 'Consentimiento'
  },
  'Consent request message': {
    'en-US': null,
    'pt-BR': 'Mensagem de solicitação de consentimento',
    'es-ES': 'Mensaje de solicitud de consentimiento'
  },
  'Request consent confirmation (Checkbox)': {
    'en-US': null,
    'pt-BR': 'Solicitar confirmação de consentimento (Checkbox de aceite)',
    'es-ES': 'Solicitar confirmación de consentimiento (Checkbox)'
  },
  'Display privacy notice only (No checkbox)': {
    'en-US': null,
    'pt-BR': 'Apenas exibir aviso de privacidade (Sem checkbox de aceite)',
    'es-ES': 'Mostrar solo aviso de privacidad (Sin checkbox)'
  },
  'Consent option on the application form': {
    'en-US': null,
    'pt-BR': 'Opção de consentimento no formulário de candidatura',
    'es-ES': 'Opción de consentimiento en el formulario de solicitud'
  },
  'Insert consent option for applications made on the career page': {
    'en-US': null,
    'pt-BR': 'Inserir opção de consentimento para candidaturas realizadas na página de carreira',
    'es-ES': 'Insertar opción de consentimiento para solicitudes realizadas en la página de carrera'
  },
  'Expiration of candidates (In days)': {
    'en-US': null,
    'pt-BR': 'Expiração de candidatos (Em dias)',
    'es-ES': 'Vencimiento de candidatos (En días)'
  },
  'Groups': {
    'en-US': null,
    'pt-BR': 'Grupos',
    'es-ES': 'Grupos'
  },
  'Key': {
    'en-US': null,
    'pt-BR': 'Chave',
    'es-ES': 'Llave'
  },
  'File type': {
    'en-US': null,
    'pt-BR': 'Tipo de arquivo',
    'es-ES': 'Tipo de archivo'
  },
  'Select the file': {
    'en-US': null,
    'pt-BR': 'Selecione o arquivo',
    'es-ES': 'Seleccione el archivo'
  },
  'Messaging': {
    'en-US': null,
    'pt-BR': 'Mensagens',
    'es-ES': 'Mensajes'
  },
  'Search conversations': {
    'en-US': null,
    'pt-BR': 'Buscar conversas',
    'es-ES': 'Buscar conversaciones'
  },
  'Assigned to me': {
    'en-US': null,
    'pt-BR': 'Atribuídas a mim',
    'es-ES': 'Asignadas a mí'
  },
  'No conversations': {
    'en-US': null,
    'pt-BR': 'Nenhuma conversa',
    'es-ES': 'Sin conversaciones'
  },
  'Conversations': {
    'en-US': null,
    'pt-BR': 'Conversas',
    'es-ES': 'Conversaciones'
  },
  'No name': {
    'en-US': null,
    'pt-BR': 'Sem nome',
    'es-ES': 'Sin nombre'
  },
  'No messages yet': {
    'en-US': null,
    'pt-BR': 'Nenhuma mensagem ainda',
    'es-ES': 'Aún no hay mensajes'
  },
  'Search user': {
    'en-US': null,
    'pt-BR': 'Buscar usuário',
    'es-ES': 'Buscar usuario'
  },
  'Unassigned': {
    'en-US': null,
    'pt-BR': 'Não atribuído',
    'es-ES': 'No asignado'
  },
  'No users found': {
    'en-US': null,
    'pt-BR': 'Nenhum usuário encontrado',
    'es-ES': 'No se encontraron usuarios'
  },
  'Assigned': {
    'en-US': null,
    'pt-BR': 'Atribuído',
    'es-ES': 'Asignado'
  },
  'Unarchive': {
    'en-US': null,
    'pt-BR': 'Desarquivar',
    'es-ES': 'Desarchivar'
  },
  'Could not load the conversation': {
    'en-US': null,
    'pt-BR': 'Não foi possível carregar a conversa',
    'es-ES': 'No se pudo cargar la conversación'
  },
  'Could not send the message': {
    'en-US': null,
    'pt-BR': 'Não foi possível enviar a mensagem',
    'es-ES': 'No se pudo enviar el mensaje'
  },
  'Today': {
    'en-US': null,
    'pt-BR': 'Hoje',
    'es-ES': 'Hoy'
  },
  'Yesterday': {
    'en-US': null,
    'pt-BR': 'Ontem',
    'es-ES': 'Ayer'
  },
  'Template': {
    'en-US': null,
    'pt-BR': 'Modelo',
    'es-ES': 'Plantilla'
  },
  'Sending': {
    'en-US': null,
    'pt-BR': 'Enviando',
    'es-ES': 'Enviando'
  },
  'Delivered': {
    'en-US': null,
    'pt-BR': 'Entregue',
    'es-ES': 'Entregado'
  },
  'Failed': {
    'en-US': null,
    'pt-BR': 'Falhou',
    'es-ES': 'Falló'
  },
  'No channel available to send messages': {
    'en-US': null,
    'pt-BR': 'Nenhum canal disponível para enviar mensagens',
    'es-ES': 'No hay canal disponible para enviar mensajes'
  },
  'Learn how to connect the WhatsApp API': {
    'en-US': null,
    'pt-BR': 'Saiba como conectar a API do WhatsApp',
    'es-ES': 'Aprende a conectar la API de WhatsApp'
  },
  'Send template': {
    'en-US': null,
    'pt-BR': 'Enviar modelo',
    'es-ES': 'Enviar plantilla'
  },
  'Audio': {
    'en-US': null,
    'pt-BR': 'Áudio',
    'es-ES': 'Audio'
  },
  'Document': {
    'en-US': null,
    'pt-BR': 'Documento',
    'es-ES': 'Documento'
  },
  'Uploading the file': {
    'en-US': null,
    'pt-BR': 'Enviando o arquivo',
    'es-ES': 'Subiendo el archivo'
  },
  'The file must be at most 5MB.': {
    'en-US': null,
    'pt-BR': 'O arquivo deve ter no máximo 5MB.',
    'es-ES': 'El archivo debe tener como máximo 5MB.'
  },
  'Could not upload the file': {
    'en-US': null,
    'pt-BR': 'Não foi possível enviar o arquivo',
    'es-ES': 'No se pudo subir el archivo'
  },
  'Type a message': {
    'en-US': null,
    'pt-BR': 'Digite uma mensagem',
    'es-ES': 'Escriba un mensaje'
  },
  'Choose a template': {
    'en-US': null,
    'pt-BR': 'Escolha um modelo',
    'es-ES': 'Elija una plantilla'
  },
  'Search template': {
    'en-US': null,
    'pt-BR': 'Buscar modelo',
    'es-ES': 'Buscar plantilla'
  },
  'Template preview': {
    'en-US': null,
    'pt-BR': 'Prévia do modelo',
    'es-ES': 'Vista previa de la plantilla'
  },
  'Variables': {
    'en-US': null,
    'pt-BR': 'Variáveis',
    'es-ES': 'Variables'
  },
  'Contact': {
    'en-US': null,
    'pt-BR': 'Contato',
    'es-ES': 'Contacto'
  },
  'No contact address': {
    'en-US': null,
    'pt-BR': 'Sem endereço de contato',
    'es-ES': 'Sin dirección de contacto'
  },
  'WhatsApp': {
    'en-US': null,
    'pt-BR': 'WhatsApp',
    'es-ES': 'WhatsApp'
  },
  'SMS': {
    'en-US': null,
    'pt-BR': 'SMS',
    'es-ES': 'SMS'
  },
  'No contact selected': {
    'en-US': null,
    'pt-BR': 'Nenhum contato selecionado',
    'es-ES': 'Ningún contacto seleccionado'
  },
  'Edit contact': {
    'en-US': null,
    'pt-BR': 'Editar contato',
    'es-ES': 'Editar contacto'
  },
  'Search contacts': {
    'en-US': null,
    'pt-BR': 'Buscar contatos',
    'es-ES': 'Buscar contactos'
  },
  'Add contact': {
    'en-US': null,
    'pt-BR': 'Adicionar contato',
    'es-ES': 'Agregar contacto'
  },
  'New contact': {
    'en-US': null,
    'pt-BR': 'Novo contato',
    'es-ES': 'Nuevo contacto'
  },
  'Remove conversation': {
    'en-US': null,
    'pt-BR': 'Remover conversa',
    'es-ES': 'Eliminar conversación'
  },
  'No contacts': {
    'en-US': null,
    'pt-BR': 'Nenhum contato',
    'es-ES': 'Sin contactos'
  },
  'Create': {
    'en-US': null,
    'pt-BR': 'Criar',
    'es-ES': 'Crear'
  },
  'The 24h window is closed. You can only send a template.': {
    'en-US': null,
    'pt-BR': 'A janela de 24h está fechada. Você só pode enviar um modelo.',
    'es-ES': 'La ventana de 24h está cerrada. Solo puede enviar una plantilla.'
  },
  'Assigned to': {
    'en-US': null,
    'pt-BR': 'Atribuído a',
    'es-ES': 'Asignado a'
  },
  'Me': {
    'en-US': null,
    'pt-BR': 'Mim',
    'es-ES': 'Mí'
  },
  'Unreplied': {
    'en-US': null,
    'pt-BR': 'Sem resposta',
    'es-ES': 'Sin respuesta'
  },
  'No owner': {
    'en-US': null,
    'pt-BR': 'Sem responsável',
    'es-ES': 'Sin responsable'
  },
  'Agent off and nobody assigned': {
    'en-US': null,
    'pt-BR': 'IA desligada e sem responsável',
    'es-ES': 'IA apagada y sin responsable'
  },
  'Agent': {
    'en-US': null,
    'pt-BR': 'Agente',
    'es-ES': 'Agente'
  },
  'No agent': {
    'en-US': null,
    'pt-BR': 'Sem agente',
    'es-ES': 'Sin agente'
  },
  'With agent': {
    'en-US': null,
    'pt-BR': 'Com agente',
    'es-ES': 'Con agente'
  },
  'Any': {
    'en-US': null,
    'pt-BR': 'Indiferente',
    'es-ES': 'Indiferente'
  },
  'Send a template': {
    'en-US': null,
    'pt-BR': 'Enviar um modelo',
    'es-ES': 'Enviar una plantilla'
  },
  'Attach files': {
    'en-US': null,
    'pt-BR': 'Anexar arquivos',
    'es-ES': 'Adjuntar archivos'
  },
  'Record audio': {
    'en-US': null,
    'pt-BR': 'Gravar áudio',
    'es-ES': 'Grabar audio'
  },
  'Recording': {
    'en-US': null,
    'pt-BR': 'Gravando',
    'es-ES': 'Grabando'
  },
  'Starting the recorder': {
    'en-US': null,
    'pt-BR': 'Iniciando o gravador',
    'es-ES': 'Iniciando el grabador'
  },
  'Discard': {
    'en-US': null,
    'pt-BR': 'Descartar',
    'es-ES': 'Descartar'
  },
  'Stop': {
    'en-US': null,
    'pt-BR': 'Parar',
    'es-ES': 'Detener'
  },
  'Could not access the microphone': {
    'en-US': null,
    'pt-BR': 'Não foi possível acessar o microfone',
    'es-ES': 'No se pudo acceder al micrófono'
  },
  'This browser does not support audio recording': {
    'en-US': null,
    'pt-BR': 'Este navegador não suporta gravação de áudio',
    'es-ES': 'Este navegador no soporta la grabación de audio'
  },
  'The recording failed': {
    'en-US': null,
    'pt-BR': 'A gravação falhou',
    'es-ES': 'La grabación falló'
  },
  'Preparing the audio': {
    'en-US': null,
    'pt-BR': 'Preparando o áudio',
    'es-ES': 'Preparando el audio'
  },
  'Remove this contact?': {
    'en-US': null,
    'pt-BR': 'Deseja realmente remover esse contato?',
    'es-ES': '¿Realmente desea eliminar este contacto?'
  },
  'All the messages exchanged with this contact will be removed. This operation cannot be undone.': {
    'en-US': null,
    'pt-BR': 'Todas as mensagens trocadas com esse contato serão removidas. Essa operação não poderá ser desfeita.',
    'es-ES': 'Se eliminarán todos los mensajes intercambiados con este contacto. Esta operación no se puede deshacer.'
  },
  'Associate': {
    'en-US': null,
    'pt-BR': 'Associar',
    'es-ES': 'Asociar'
  },
  'Unlink candidate': {
    'en-US': null,
    'pt-BR': 'Desassociar candidato',
    'es-ES': 'Desasociar candidato'
  },
  'Searching candidates': {
    'en-US': null,
    'pt-BR': 'Buscando candidatos',
    'es-ES': 'Buscando candidatos'
  },
  'No candidate found with this contact': {
    'en-US': null,
    'pt-BR': 'Nenhum candidato encontrado com esse contato',
    'es-ES': 'Ningún candidato encontrado con este contacto'
  },
  'WhatsApp is in beta and, during this period, conversational agent tokens will not be charged. Before charging begins, we will let you know the prices in advance and each customer will be able to choose whether to keep using the feature.': {
    'en-US': null,
    'pt-BR': 'O WhatsApp está em versão beta e, durante esse período, os tokens do agente conversacional não serão cobrados. Antes do início da cobrança, avisaremos com antecedência os valores e cada cliente poderá escolher se deseja continuar utilizando o recurso.',
    'es-ES': 'WhatsApp está en versión beta y, durante este período, los tokens del agente conversacional no se cobrarán. Antes del inicio del cobro, informaremos con anticipación los valores y cada cliente podrá elegir si desea seguir utilizando el recurso.'
  },
  'Career page settings': {
    'en-US': null,
    'pt-BR': 'Configurações da página de carreiras',
    'es-ES': 'Configuración de la página de carreras'
  }
}

const get = (lang) => {
  const obj = {}
  Object.entries(translate).forEach(v => {
    obj[v[0]] = v[1][lang] ? v[1][lang] : v[0]
  })
  return obj
}

export default {
  'en-US': get('en-US'),
  'pt-BR': get('pt-BR'),
  'es-ES': get('es-ES')
}



// WEBPACK FOOTER //
// ./src/locales/messages.js